/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminCertificationRequest,
  AdminCertificationRequestsListParams,
  AdminCommunicationsListParams,
  AdminConfigurationListParams,
  AdminCouponsListParams,
  AdminCreateBackgroundCheck,
  AdminCreateBackgroundCheckRequest,
  AdminGigApplication,
  AdminGigApplicationCancellationReversal,
  AdminGigApplicationCancellationReversalRequest,
  AdminGigApplicationsListParams,
  AdminGigsScheduleChangesListParams,
  AdminGigsterProfilesListParams,
  AdminHighDemandSurcharge,
  AdminHighDemandSurchargeRemoveRequest,
  AdminHighDemandSurchargeRestore,
  AdminHighDemandSurchargeRestoreRequest,
  AdminHighDemandSurchargesListParams,
  AdminInvoicingBackfillsListParams,
  AdminInvoicingRunsListParams,
  AdminJobPostingSerializerWithApplicationDate,
  AdminJobPostingsAppliedByProListParams,
  AdminJobPostingsListParams,
  AdminMatchDashboardAtRiskProsFilterOptionsRetrieveParams,
  AdminMatchDashboardAtRiskProsListParams,
  AdminMatchDashboardAtRiskProsSummaryRetrieveParams,
  AdminProBlockListParams,
  AdminProSickTime,
  AdminReferralCodeListParams,
  AdminScheduleChangeEvent,
  AdminSuspensionsListParams,
  AdminUsersListParams,
  AiInterviewInviteRequestRequest,
  AiInterviewInviteResponse,
  AtRiskProDismissRequestRequest,
  AtRiskProDismissResponse,
  AtRiskProFilterOptions,
  AtRiskProSummary,
  CertificationMarketLinkAdmin,
  CertificationMarketLinkAdminRequest,
  CertificationMarketLinkBulkItemRequest,
  Configuration,
  ConfigurationRequest,
  CreateManualReferralCode,
  CreateManualReferralCodeRequest,
  Credit,
  CreditRequest,
  GigsterBlockMultiLocation,
  GigsterBlockMultiLocationRequest,
  GigsterBlockReadOnly,
  InvoicingBackfill,
  InvoicingBackfillConflictError,
  InvoicingBackfillCreateRequest,
  InvoicingLineItem,
  InvoicingLineItemManualCreateRequest,
  InvoicingRunBackfillLocked,
  InvoicingRunDeleteNeedsReconciliation,
  InvoicingRunDeleteUpstreamError,
  InvoicingRunDetail,
  InvoicingRunPaymentState,
  InvoicingRunPaymentStateUnavailable,
  InvoicingRunSendNeedsReconciliation,
  LocationOrgRemap,
  LocationOrgRemapRequest,
  ManualAssignReferralCreate,
  ManualAssignReferralCreateRequest,
  ManualReferralCode,
  NotFoundError,
  OnboardingStepOverride,
  OnboardingStepOverrideRequest,
  PaginatedAdminCertificationRequestList,
  PaginatedAdminCommunicationList,
  PaginatedAdminGigApplicationList,
  PaginatedAdminJobPostingList,
  PaginatedAdminJobPostingWithApplicationStageList,
  PaginatedAtRiskProList,
  PaginatedConfigurationList,
  PaginatedCreditList,
  PaginatedInvoicingBackfillListList,
  PaginatedInvoicingRunListList,
  PaginatedManualReferralCodeList,
  PaginatedProReadonlyList,
  PaginatedSuspensionList,
  PaginatedUserResponseList,
  PatchedAdminCertificationRequestRequest,
  PatchedAdminGigApplicationSelectOrConfirmProRequest,
  PatchedAdminJobPostingTransitionRequest,
  PatchedCertificationMarketLinkAdminRequest,
  PatchedConfigurationRequest,
  PatchedCreditRequest,
  PatchedInvoicingLineItemEditRequest,
  PatchedManualReferralCodeRequest,
  PatchedProUpdateVerificationRequest,
  PatchedSuspensionRequest,
  PermissionDeniedError,
  ProCreateVerification,
  ProCreateVerificationRequest,
  ProPaymentCreate,
  ProPaymentCreateRequest,
  ProProfileSectionResponse,
  ProUpdateVerification,
  ProUpdateVerificationRequest,
  ServiceUnavailableError,
  Suspension,
  SuspensionRequest,
  SuspensionUpdate,
  SuspensionUpdateRequest,
  SwapPhoneNumbers,
  SwapPhoneNumbersRequest,
  UpdateCredit,
  UpdateCreditRequest,
  UpdateManualReferralCode,
  UpdateManualReferralCodeRequest,
  W2EmploymentStatusResponse,
  W2EmploymentStatusUpdateRequest,
  W2TerminationImpact,
  _ApproveResponse
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getAdminBackgroundChecksCreateUrl = () => {




  return `/api/admin/background-checks/`
}

export const adminBackgroundChecksCreate = async (adminCreateBackgroundCheckRequest: AdminCreateBackgroundCheckRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminCreateBackgroundCheck> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminCreateBackgroundCheck>(getAdminBackgroundChecksCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminCreateBackgroundCheckRequest)
  }
);}





export const getAdminBackgroundChecksCreateMutationKey = () => ['adminBackgroundChecksCreate'] as const;

export const getAdminBackgroundChecksCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminBackgroundChecksCreate>>, TError,AdminBackgroundChecksCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminBackgroundChecksCreate>>, TError,AdminBackgroundChecksCreateMutationVariables, TContext> => {

const mutationKey = getAdminBackgroundChecksCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminBackgroundChecksCreate>>, AdminBackgroundChecksCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminBackgroundChecksCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminBackgroundChecksCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminBackgroundChecksCreate>>>
    export type AdminBackgroundChecksCreateMutationBody = AdminCreateBackgroundCheckRequest
    export type AdminBackgroundChecksCreateMutationError = void
    export type AdminBackgroundChecksCreateMutationVariables = {data: AdminCreateBackgroundCheckRequest}

    export const useAdminBackgroundChecksCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminBackgroundChecksCreate>>, TError,AdminBackgroundChecksCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminBackgroundChecksCreate>>,
        TError,
        AdminBackgroundChecksCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminBackgroundChecksCreateMutationOptions(options), queryClient);
    }
    export const getAdminCertificationRequestsListUrl = (params?: AdminCertificationRequestsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/certification-requests/?${stringifiedParams}` : `/api/admin/certification-requests/`
}

export const adminCertificationRequestsList = async (params?: AdminCertificationRequestsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedAdminCertificationRequestList> => {

  return customFetch<PaginatedAdminCertificationRequestList>(getAdminCertificationRequestsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCertificationRequestsListInfiniteQueryKey = (params?: AdminCertificationRequestsListParams,) => {
    return [
    'infinite', `/api/admin/certification-requests/`, ...(params ? [params] : [])
    ] as const;
    }

export const getAdminCertificationRequestsListQueryKey = (params?: AdminCertificationRequestsListParams,) => {
    return [
    `/api/admin/certification-requests/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminCertificationRequestsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof adminCertificationRequestsList>>, AdminCertificationRequestsListParams['page']>, TError = void>(params?: AdminCertificationRequestsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminCertificationRequestsList>>, TError, TData, QueryKey, AdminCertificationRequestsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCertificationRequestsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCertificationRequestsList>>, QueryKey, AdminCertificationRequestsListParams['page']> = ({ signal, pageParam }) => adminCertificationRequestsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminCertificationRequestsList>>, TError, TData, QueryKey, AdminCertificationRequestsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCertificationRequestsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminCertificationRequestsList>>>
export type AdminCertificationRequestsListInfiniteQueryError = void


export function useAdminCertificationRequestsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminCertificationRequestsList>>, AdminCertificationRequestsListParams['page']>, TError = void>(
 params: undefined |  AdminCertificationRequestsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminCertificationRequestsList>>, TError, TData, QueryKey, AdminCertificationRequestsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCertificationRequestsList>>,
          TError,
          Awaited<ReturnType<typeof adminCertificationRequestsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCertificationRequestsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminCertificationRequestsList>>, AdminCertificationRequestsListParams['page']>, TError = void>(
 params?: AdminCertificationRequestsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminCertificationRequestsList>>, TError, TData, QueryKey, AdminCertificationRequestsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCertificationRequestsList>>,
          TError,
          Awaited<ReturnType<typeof adminCertificationRequestsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCertificationRequestsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminCertificationRequestsList>>, AdminCertificationRequestsListParams['page']>, TError = void>(
 params?: AdminCertificationRequestsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminCertificationRequestsList>>, TError, TData, QueryKey, AdminCertificationRequestsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCertificationRequestsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminCertificationRequestsList>>, AdminCertificationRequestsListParams['page']>, TError = void>(
 params?: AdminCertificationRequestsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminCertificationRequestsList>>, TError, TData, QueryKey, AdminCertificationRequestsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCertificationRequestsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminCertificationRequestsListQueryOptions = <TData = Awaited<ReturnType<typeof adminCertificationRequestsList>>, TError = void>(params?: AdminCertificationRequestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCertificationRequestsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCertificationRequestsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCertificationRequestsList>>> = ({ signal }) => adminCertificationRequestsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCertificationRequestsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCertificationRequestsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminCertificationRequestsList>>>
export type AdminCertificationRequestsListQueryError = void


export function useAdminCertificationRequestsList<TData = Awaited<ReturnType<typeof adminCertificationRequestsList>>, TError = void>(
 params: undefined |  AdminCertificationRequestsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCertificationRequestsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCertificationRequestsList>>,
          TError,
          Awaited<ReturnType<typeof adminCertificationRequestsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCertificationRequestsList<TData = Awaited<ReturnType<typeof adminCertificationRequestsList>>, TError = void>(
 params?: AdminCertificationRequestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCertificationRequestsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCertificationRequestsList>>,
          TError,
          Awaited<ReturnType<typeof adminCertificationRequestsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCertificationRequestsList<TData = Awaited<ReturnType<typeof adminCertificationRequestsList>>, TError = void>(
 params?: AdminCertificationRequestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCertificationRequestsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCertificationRequestsList<TData = Awaited<ReturnType<typeof adminCertificationRequestsList>>, TError = void>(
 params?: AdminCertificationRequestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCertificationRequestsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCertificationRequestsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminCertificationRequestsRetrieveUrl = (id: string,) => {




  return `/api/admin/certification-requests/${id}/`
}

export const adminCertificationRequestsRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<AdminCertificationRequest> => {

  return customFetch<AdminCertificationRequest>(getAdminCertificationRequestsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCertificationRequestsRetrieveQueryKey = (id: string,) => {
    return [
    `/api/admin/certification-requests/${id}/`
    ] as const;
    }


export const getAdminCertificationRequestsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminCertificationRequestsRetrieve>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCertificationRequestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCertificationRequestsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCertificationRequestsRetrieve>>> = ({ signal }) => adminCertificationRequestsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCertificationRequestsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCertificationRequestsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminCertificationRequestsRetrieve>>>
export type AdminCertificationRequestsRetrieveQueryError = void


export function useAdminCertificationRequestsRetrieve<TData = Awaited<ReturnType<typeof adminCertificationRequestsRetrieve>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCertificationRequestsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCertificationRequestsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCertificationRequestsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCertificationRequestsRetrieve<TData = Awaited<ReturnType<typeof adminCertificationRequestsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCertificationRequestsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCertificationRequestsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCertificationRequestsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCertificationRequestsRetrieve<TData = Awaited<ReturnType<typeof adminCertificationRequestsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCertificationRequestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCertificationRequestsRetrieve<TData = Awaited<ReturnType<typeof adminCertificationRequestsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCertificationRequestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCertificationRequestsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminCertificationRequestsPartialUpdateUrl = (id: string,) => {




  return `/api/admin/certification-requests/${id}/`
}

export const adminCertificationRequestsPartialUpdate = async (id: string,
    patchedAdminCertificationRequestRequest?: PatchedAdminCertificationRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminCertificationRequest> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminCertificationRequest>(getAdminCertificationRequestsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedAdminCertificationRequestRequest)
  }
);}





export const getAdminCertificationRequestsPartialUpdateMutationKey = () => ['adminCertificationRequestsPartialUpdate'] as const;

export const getAdminCertificationRequestsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCertificationRequestsPartialUpdate>>, TError,AdminCertificationRequestsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCertificationRequestsPartialUpdate>>, TError,AdminCertificationRequestsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminCertificationRequestsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCertificationRequestsPartialUpdate>>, AdminCertificationRequestsPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  adminCertificationRequestsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCertificationRequestsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCertificationRequestsPartialUpdate>>>
    export type AdminCertificationRequestsPartialUpdateMutationBody = PatchedAdminCertificationRequestRequest | undefined
    export type AdminCertificationRequestsPartialUpdateMutationError = void
    export type AdminCertificationRequestsPartialUpdateMutationVariables = {id: string;data?: PatchedAdminCertificationRequestRequest}

    export const useAdminCertificationRequestsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCertificationRequestsPartialUpdate>>, TError,AdminCertificationRequestsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCertificationRequestsPartialUpdate>>,
        TError,
        AdminCertificationRequestsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCertificationRequestsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getAdminCertificationRequestsDestroyUrl = (id: string,) => {




  return `/api/admin/certification-requests/${id}/`
}

export const adminCertificationRequestsDestroy = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getAdminCertificationRequestsDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminCertificationRequestsDestroyMutationKey = () => ['adminCertificationRequestsDestroy'] as const;

export const getAdminCertificationRequestsDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCertificationRequestsDestroy>>, TError,AdminCertificationRequestsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCertificationRequestsDestroy>>, TError,AdminCertificationRequestsDestroyMutationVariables, TContext> => {

const mutationKey = getAdminCertificationRequestsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCertificationRequestsDestroy>>, AdminCertificationRequestsDestroyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  adminCertificationRequestsDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCertificationRequestsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminCertificationRequestsDestroy>>>

    export type AdminCertificationRequestsDestroyMutationError = void
    export type AdminCertificationRequestsDestroyMutationVariables = {id: string}

    export const useAdminCertificationRequestsDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCertificationRequestsDestroy>>, TError,AdminCertificationRequestsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCertificationRequestsDestroy>>,
        TError,
        AdminCertificationRequestsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCertificationRequestsDestroyMutationOptions(options), queryClient);
    }
    export const getAdminCertificationsMarketLinksListUrl = (certificationId: number,) => {




  return `/api/admin/certifications/${certificationId}/market-links/`
}

/**
 * Admin-only CRUD for CertificationMarketLink.
 *
 * URL: ``/api/admin/certifications/<certification_id>/market-links/``
 * Permission: ``IsGigproAdminPermission`` — not flag-gated.
 *
 * A Certification is "market-aware" iff it has at least one
 * CertificationMarketLink row (derived, no explicit scope field). Admin
 * must configure links before locations flip to v4.
 */
export const adminCertificationsMarketLinksList = async (certificationId: number, options?: Parameters<typeof customFetch>[1]): Promise<CertificationMarketLinkAdmin[]> => {

  return customFetch<CertificationMarketLinkAdmin[]>(getAdminCertificationsMarketLinksListUrl(certificationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCertificationsMarketLinksListQueryKey = (certificationId: number,) => {
    return [
    `/api/admin/certifications/${certificationId}/market-links/`
    ] as const;
    }


export const getAdminCertificationsMarketLinksListQueryOptions = <TData = Awaited<ReturnType<typeof adminCertificationsMarketLinksList>>, TError = void>(certificationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCertificationsMarketLinksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCertificationsMarketLinksListQueryKey(certificationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCertificationsMarketLinksList>>> = ({ signal }) => adminCertificationsMarketLinksList(certificationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: certificationId !== null && certificationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCertificationsMarketLinksList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCertificationsMarketLinksListQueryResult = NonNullable<Awaited<ReturnType<typeof adminCertificationsMarketLinksList>>>
export type AdminCertificationsMarketLinksListQueryError = void


export function useAdminCertificationsMarketLinksList<TData = Awaited<ReturnType<typeof adminCertificationsMarketLinksList>>, TError = void>(
 certificationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCertificationsMarketLinksList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCertificationsMarketLinksList>>,
          TError,
          Awaited<ReturnType<typeof adminCertificationsMarketLinksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCertificationsMarketLinksList<TData = Awaited<ReturnType<typeof adminCertificationsMarketLinksList>>, TError = void>(
 certificationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCertificationsMarketLinksList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCertificationsMarketLinksList>>,
          TError,
          Awaited<ReturnType<typeof adminCertificationsMarketLinksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCertificationsMarketLinksList<TData = Awaited<ReturnType<typeof adminCertificationsMarketLinksList>>, TError = void>(
 certificationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCertificationsMarketLinksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCertificationsMarketLinksList<TData = Awaited<ReturnType<typeof adminCertificationsMarketLinksList>>, TError = void>(
 certificationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCertificationsMarketLinksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCertificationsMarketLinksListQueryOptions(certificationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminCertificationsMarketLinksCreateUrl = (certificationId: number,) => {




  return `/api/admin/certifications/${certificationId}/market-links/`
}

/**
 * Admin-only CRUD for CertificationMarketLink.
 *
 * URL: ``/api/admin/certifications/<certification_id>/market-links/``
 * Permission: ``IsGigproAdminPermission`` — not flag-gated.
 *
 * A Certification is "market-aware" iff it has at least one
 * CertificationMarketLink row (derived, no explicit scope field). Admin
 * must configure links before locations flip to v4.
 */
export const adminCertificationsMarketLinksCreate = async (certificationId: number,
    certificationMarketLinkAdminRequest: CertificationMarketLinkAdminRequest, options?: Parameters<typeof customFetch>[1]): Promise<CertificationMarketLinkAdmin> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<CertificationMarketLinkAdmin>(getAdminCertificationsMarketLinksCreateUrl(certificationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(certificationMarketLinkAdminRequest)
  }
);}





export const getAdminCertificationsMarketLinksCreateMutationKey = () => ['adminCertificationsMarketLinksCreate'] as const;

export const getAdminCertificationsMarketLinksCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCertificationsMarketLinksCreate>>, TError,AdminCertificationsMarketLinksCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCertificationsMarketLinksCreate>>, TError,AdminCertificationsMarketLinksCreateMutationVariables, TContext> => {

const mutationKey = getAdminCertificationsMarketLinksCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCertificationsMarketLinksCreate>>, AdminCertificationsMarketLinksCreateMutationVariables> = (props) => {
          const {certificationId,data} = props ?? {};

          return  adminCertificationsMarketLinksCreate(certificationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCertificationsMarketLinksCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCertificationsMarketLinksCreate>>>
    export type AdminCertificationsMarketLinksCreateMutationBody = CertificationMarketLinkAdminRequest
    export type AdminCertificationsMarketLinksCreateMutationError = void
    export type AdminCertificationsMarketLinksCreateMutationVariables = {certificationId: number;data: CertificationMarketLinkAdminRequest}

    export const useAdminCertificationsMarketLinksCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCertificationsMarketLinksCreate>>, TError,AdminCertificationsMarketLinksCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCertificationsMarketLinksCreate>>,
        TError,
        AdminCertificationsMarketLinksCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCertificationsMarketLinksCreateMutationOptions(options), queryClient);
    }
    export const getAdminCertificationsMarketLinksUpdateUrl = (certificationId: number,) => {




  return `/api/admin/certifications/${certificationId}/market-links/`
}

/**
 * Replace the cert's entire market-link set in one request.
 *
 * The body is the COMPLETE desired state — a list of ``{market, instructional_url}`` (``custom_messaging``
 * optional; omitting it preserves the existing value). Markets present are upserted; existing links whose
 * market is omitted are deleted. Collapses the admin UI's per-market write fan-out (one HTTP request per
 * market) into a single atomic transaction with one cache invalidation.
 */
export const adminCertificationsMarketLinksUpdate = async (certificationId: number,
    certificationMarketLinkBulkItemRequest: CertificationMarketLinkBulkItemRequest[], options?: Parameters<typeof customFetch>[1]): Promise<CertificationMarketLinkAdmin[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<CertificationMarketLinkAdmin[]>(getAdminCertificationsMarketLinksUpdateUrl(certificationId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(certificationMarketLinkBulkItemRequest)
  }
);}





export const getAdminCertificationsMarketLinksUpdateMutationKey = () => ['adminCertificationsMarketLinksUpdate'] as const;

export const getAdminCertificationsMarketLinksUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCertificationsMarketLinksUpdate>>, TError,AdminCertificationsMarketLinksUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCertificationsMarketLinksUpdate>>, TError,AdminCertificationsMarketLinksUpdateMutationVariables, TContext> => {

const mutationKey = getAdminCertificationsMarketLinksUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCertificationsMarketLinksUpdate>>, AdminCertificationsMarketLinksUpdateMutationVariables> = (props) => {
          const {certificationId,data} = props ?? {};

          return  adminCertificationsMarketLinksUpdate(certificationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCertificationsMarketLinksUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCertificationsMarketLinksUpdate>>>
    export type AdminCertificationsMarketLinksUpdateMutationBody = CertificationMarketLinkBulkItemRequest[]
    export type AdminCertificationsMarketLinksUpdateMutationError = void
    export type AdminCertificationsMarketLinksUpdateMutationVariables = {certificationId: number;data: CertificationMarketLinkBulkItemRequest[]}

    export const useAdminCertificationsMarketLinksUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCertificationsMarketLinksUpdate>>, TError,AdminCertificationsMarketLinksUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCertificationsMarketLinksUpdate>>,
        TError,
        AdminCertificationsMarketLinksUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCertificationsMarketLinksUpdateMutationOptions(options), queryClient);
    }
    export const getAdminCertificationsMarketLinksRetrieveUrl = (certificationId: number,
    id: number,) => {




  return `/api/admin/certifications/${certificationId}/market-links/${id}/`
}

/**
 * Admin-only CRUD for CertificationMarketLink.
 *
 * URL: ``/api/admin/certifications/<certification_id>/market-links/``
 * Permission: ``IsGigproAdminPermission`` — not flag-gated.
 *
 * A Certification is "market-aware" iff it has at least one
 * CertificationMarketLink row (derived, no explicit scope field). Admin
 * must configure links before locations flip to v4.
 */
export const adminCertificationsMarketLinksRetrieve = async (certificationId: number,
    id: number, options?: Parameters<typeof customFetch>[1]): Promise<CertificationMarketLinkAdmin> => {

  return customFetch<CertificationMarketLinkAdmin>(getAdminCertificationsMarketLinksRetrieveUrl(certificationId,id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCertificationsMarketLinksRetrieveQueryKey = (certificationId: number,
    id: number,) => {
    return [
    `/api/admin/certifications/${certificationId}/market-links/${id}/`
    ] as const;
    }


export const getAdminCertificationsMarketLinksRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminCertificationsMarketLinksRetrieve>>, TError = void>(certificationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCertificationsMarketLinksRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCertificationsMarketLinksRetrieveQueryKey(certificationId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCertificationsMarketLinksRetrieve>>> = ({ signal }) => adminCertificationsMarketLinksRetrieve(certificationId,id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: certificationId !== null && certificationId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCertificationsMarketLinksRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCertificationsMarketLinksRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminCertificationsMarketLinksRetrieve>>>
export type AdminCertificationsMarketLinksRetrieveQueryError = void


export function useAdminCertificationsMarketLinksRetrieve<TData = Awaited<ReturnType<typeof adminCertificationsMarketLinksRetrieve>>, TError = void>(
 certificationId: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCertificationsMarketLinksRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCertificationsMarketLinksRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCertificationsMarketLinksRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCertificationsMarketLinksRetrieve<TData = Awaited<ReturnType<typeof adminCertificationsMarketLinksRetrieve>>, TError = void>(
 certificationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCertificationsMarketLinksRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCertificationsMarketLinksRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCertificationsMarketLinksRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCertificationsMarketLinksRetrieve<TData = Awaited<ReturnType<typeof adminCertificationsMarketLinksRetrieve>>, TError = void>(
 certificationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCertificationsMarketLinksRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCertificationsMarketLinksRetrieve<TData = Awaited<ReturnType<typeof adminCertificationsMarketLinksRetrieve>>, TError = void>(
 certificationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCertificationsMarketLinksRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCertificationsMarketLinksRetrieveQueryOptions(certificationId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminCertificationsMarketLinksPartialUpdateUrl = (certificationId: number,
    id: number,) => {




  return `/api/admin/certifications/${certificationId}/market-links/${id}/`
}

/**
 * Admin-only CRUD for CertificationMarketLink.
 *
 * URL: ``/api/admin/certifications/<certification_id>/market-links/``
 * Permission: ``IsGigproAdminPermission`` — not flag-gated.
 *
 * A Certification is "market-aware" iff it has at least one
 * CertificationMarketLink row (derived, no explicit scope field). Admin
 * must configure links before locations flip to v4.
 */
export const adminCertificationsMarketLinksPartialUpdate = async (certificationId: number,
    id: number,
    patchedCertificationMarketLinkAdminRequest?: PatchedCertificationMarketLinkAdminRequest, options?: Parameters<typeof customFetch>[1]): Promise<CertificationMarketLinkAdmin> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<CertificationMarketLinkAdmin>(getAdminCertificationsMarketLinksPartialUpdateUrl(certificationId,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedCertificationMarketLinkAdminRequest)
  }
);}





export const getAdminCertificationsMarketLinksPartialUpdateMutationKey = () => ['adminCertificationsMarketLinksPartialUpdate'] as const;

export const getAdminCertificationsMarketLinksPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCertificationsMarketLinksPartialUpdate>>, TError,AdminCertificationsMarketLinksPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCertificationsMarketLinksPartialUpdate>>, TError,AdminCertificationsMarketLinksPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminCertificationsMarketLinksPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCertificationsMarketLinksPartialUpdate>>, AdminCertificationsMarketLinksPartialUpdateMutationVariables> = (props) => {
          const {certificationId,id,data} = props ?? {};

          return  adminCertificationsMarketLinksPartialUpdate(certificationId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCertificationsMarketLinksPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCertificationsMarketLinksPartialUpdate>>>
    export type AdminCertificationsMarketLinksPartialUpdateMutationBody = PatchedCertificationMarketLinkAdminRequest | undefined
    export type AdminCertificationsMarketLinksPartialUpdateMutationError = void
    export type AdminCertificationsMarketLinksPartialUpdateMutationVariables = {certificationId: number;id: number;data?: PatchedCertificationMarketLinkAdminRequest}

    export const useAdminCertificationsMarketLinksPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCertificationsMarketLinksPartialUpdate>>, TError,AdminCertificationsMarketLinksPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCertificationsMarketLinksPartialUpdate>>,
        TError,
        AdminCertificationsMarketLinksPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCertificationsMarketLinksPartialUpdateMutationOptions(options), queryClient);
    }
    export const getAdminCertificationsMarketLinksDestroyUrl = (certificationId: number,
    id: number,) => {




  return `/api/admin/certifications/${certificationId}/market-links/${id}/`
}

/**
 * Admin-only CRUD for CertificationMarketLink.
 *
 * URL: ``/api/admin/certifications/<certification_id>/market-links/``
 * Permission: ``IsGigproAdminPermission`` — not flag-gated.
 *
 * A Certification is "market-aware" iff it has at least one
 * CertificationMarketLink row (derived, no explicit scope field). Admin
 * must configure links before locations flip to v4.
 */
export const adminCertificationsMarketLinksDestroy = async (certificationId: number,
    id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getAdminCertificationsMarketLinksDestroyUrl(certificationId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminCertificationsMarketLinksDestroyMutationKey = () => ['adminCertificationsMarketLinksDestroy'] as const;

export const getAdminCertificationsMarketLinksDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCertificationsMarketLinksDestroy>>, TError,AdminCertificationsMarketLinksDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCertificationsMarketLinksDestroy>>, TError,AdminCertificationsMarketLinksDestroyMutationVariables, TContext> => {

const mutationKey = getAdminCertificationsMarketLinksDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCertificationsMarketLinksDestroy>>, AdminCertificationsMarketLinksDestroyMutationVariables> = (props) => {
          const {certificationId,id} = props ?? {};

          return  adminCertificationsMarketLinksDestroy(certificationId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCertificationsMarketLinksDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminCertificationsMarketLinksDestroy>>>

    export type AdminCertificationsMarketLinksDestroyMutationError = void
    export type AdminCertificationsMarketLinksDestroyMutationVariables = {certificationId: number;id: number}

    export const useAdminCertificationsMarketLinksDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCertificationsMarketLinksDestroy>>, TError,AdminCertificationsMarketLinksDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCertificationsMarketLinksDestroy>>,
        TError,
        AdminCertificationsMarketLinksDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCertificationsMarketLinksDestroyMutationOptions(options), queryClient);
    }
    export const getAdminCommunicationsListUrl = (params: AdminCommunicationsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/communications/?${stringifiedParams}` : `/api/admin/communications/`
}

/**
 * List communications for a (gig, pro) pair — admin Command Center.
 *
 * Read-only audit view. Surfaces the rows that ``CommunicationService``
 * has logged so staffers can answer "did we reach this pro for this gig,
 * and what did they actually receive?" without dropping into a Django
 * shell.
 *
 * *Required* ``gig_id`` and ``pro_id`` query params — enforced in
 * ``get_queryset`` rather than at the FilterSet level so the response is
 * 400 with a structured message instead of an unscoped table dump. This
 * is the security guardrail: even though the model has indexes that make
 * unfiltered queries cheap, surfacing the entire communications log via
 * an admin URL would leak send patterns across pros without operational
 * need.
 */
export const adminCommunicationsList = async (params: AdminCommunicationsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedAdminCommunicationList> => {

  return customFetch<PaginatedAdminCommunicationList>(getAdminCommunicationsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCommunicationsListInfiniteQueryKey = (params?: AdminCommunicationsListParams,) => {
    return [
    'infinite', `/api/admin/communications/`, ...(params ? [params] : [])
    ] as const;
    }

export const getAdminCommunicationsListQueryKey = (params?: AdminCommunicationsListParams,) => {
    return [
    `/api/admin/communications/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminCommunicationsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof adminCommunicationsList>>, AdminCommunicationsListParams['page']>, TError = void>(params: AdminCommunicationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminCommunicationsList>>, TError, TData, QueryKey, AdminCommunicationsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCommunicationsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCommunicationsList>>, QueryKey, AdminCommunicationsListParams['page']> = ({ signal, pageParam }) => adminCommunicationsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminCommunicationsList>>, TError, TData, QueryKey, AdminCommunicationsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCommunicationsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminCommunicationsList>>>
export type AdminCommunicationsListInfiniteQueryError = void


export function useAdminCommunicationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminCommunicationsList>>, AdminCommunicationsListParams['page']>, TError = void>(
 params: AdminCommunicationsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminCommunicationsList>>, TError, TData, QueryKey, AdminCommunicationsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCommunicationsList>>,
          TError,
          Awaited<ReturnType<typeof adminCommunicationsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCommunicationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminCommunicationsList>>, AdminCommunicationsListParams['page']>, TError = void>(
 params: AdminCommunicationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminCommunicationsList>>, TError, TData, QueryKey, AdminCommunicationsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCommunicationsList>>,
          TError,
          Awaited<ReturnType<typeof adminCommunicationsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCommunicationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminCommunicationsList>>, AdminCommunicationsListParams['page']>, TError = void>(
 params: AdminCommunicationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminCommunicationsList>>, TError, TData, QueryKey, AdminCommunicationsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCommunicationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminCommunicationsList>>, AdminCommunicationsListParams['page']>, TError = void>(
 params: AdminCommunicationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminCommunicationsList>>, TError, TData, QueryKey, AdminCommunicationsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCommunicationsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminCommunicationsListQueryOptions = <TData = Awaited<ReturnType<typeof adminCommunicationsList>>, TError = void>(params: AdminCommunicationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCommunicationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCommunicationsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCommunicationsList>>> = ({ signal }) => adminCommunicationsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCommunicationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCommunicationsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminCommunicationsList>>>
export type AdminCommunicationsListQueryError = void


export function useAdminCommunicationsList<TData = Awaited<ReturnType<typeof adminCommunicationsList>>, TError = void>(
 params: AdminCommunicationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCommunicationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCommunicationsList>>,
          TError,
          Awaited<ReturnType<typeof adminCommunicationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCommunicationsList<TData = Awaited<ReturnType<typeof adminCommunicationsList>>, TError = void>(
 params: AdminCommunicationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCommunicationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCommunicationsList>>,
          TError,
          Awaited<ReturnType<typeof adminCommunicationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCommunicationsList<TData = Awaited<ReturnType<typeof adminCommunicationsList>>, TError = void>(
 params: AdminCommunicationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCommunicationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCommunicationsList<TData = Awaited<ReturnType<typeof adminCommunicationsList>>, TError = void>(
 params: AdminCommunicationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCommunicationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCommunicationsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminConfigurationListUrl = (params?: AdminConfigurationListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/configuration/?${stringifiedParams}` : `/api/admin/configuration/`
}

/**
 * Configuration objects that are used to set various GigPro API system state parameters.
 */
export const adminConfigurationList = async (params?: AdminConfigurationListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedConfigurationList> => {

  return customFetch<PaginatedConfigurationList>(getAdminConfigurationListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminConfigurationListInfiniteQueryKey = (params?: AdminConfigurationListParams,) => {
    return [
    'infinite', `/api/admin/configuration/`, ...(params ? [params] : [])
    ] as const;
    }

export const getAdminConfigurationListQueryKey = (params?: AdminConfigurationListParams,) => {
    return [
    `/api/admin/configuration/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminConfigurationListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof adminConfigurationList>>, AdminConfigurationListParams['page']>, TError = void>(params?: AdminConfigurationListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminConfigurationList>>, TError, TData, QueryKey, AdminConfigurationListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminConfigurationListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminConfigurationList>>, QueryKey, AdminConfigurationListParams['page']> = ({ signal, pageParam }) => adminConfigurationList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminConfigurationList>>, TError, TData, QueryKey, AdminConfigurationListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminConfigurationListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminConfigurationList>>>
export type AdminConfigurationListInfiniteQueryError = void


export function useAdminConfigurationListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminConfigurationList>>, AdminConfigurationListParams['page']>, TError = void>(
 params: undefined |  AdminConfigurationListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminConfigurationList>>, TError, TData, QueryKey, AdminConfigurationListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminConfigurationList>>,
          TError,
          Awaited<ReturnType<typeof adminConfigurationList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminConfigurationListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminConfigurationList>>, AdminConfigurationListParams['page']>, TError = void>(
 params?: AdminConfigurationListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminConfigurationList>>, TError, TData, QueryKey, AdminConfigurationListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminConfigurationList>>,
          TError,
          Awaited<ReturnType<typeof adminConfigurationList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminConfigurationListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminConfigurationList>>, AdminConfigurationListParams['page']>, TError = void>(
 params?: AdminConfigurationListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminConfigurationList>>, TError, TData, QueryKey, AdminConfigurationListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminConfigurationListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminConfigurationList>>, AdminConfigurationListParams['page']>, TError = void>(
 params?: AdminConfigurationListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminConfigurationList>>, TError, TData, QueryKey, AdminConfigurationListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminConfigurationListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminConfigurationListQueryOptions = <TData = Awaited<ReturnType<typeof adminConfigurationList>>, TError = void>(params?: AdminConfigurationListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminConfigurationList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminConfigurationListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminConfigurationList>>> = ({ signal }) => adminConfigurationList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminConfigurationList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminConfigurationListQueryResult = NonNullable<Awaited<ReturnType<typeof adminConfigurationList>>>
export type AdminConfigurationListQueryError = void


export function useAdminConfigurationList<TData = Awaited<ReturnType<typeof adminConfigurationList>>, TError = void>(
 params: undefined |  AdminConfigurationListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminConfigurationList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminConfigurationList>>,
          TError,
          Awaited<ReturnType<typeof adminConfigurationList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminConfigurationList<TData = Awaited<ReturnType<typeof adminConfigurationList>>, TError = void>(
 params?: AdminConfigurationListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminConfigurationList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminConfigurationList>>,
          TError,
          Awaited<ReturnType<typeof adminConfigurationList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminConfigurationList<TData = Awaited<ReturnType<typeof adminConfigurationList>>, TError = void>(
 params?: AdminConfigurationListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminConfigurationList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminConfigurationList<TData = Awaited<ReturnType<typeof adminConfigurationList>>, TError = void>(
 params?: AdminConfigurationListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminConfigurationList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminConfigurationListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminConfigurationCreateUrl = () => {




  return `/api/admin/configuration/`
}

/**
 * Configuration objects that are used to set various GigPro API system state parameters.
 */
export const adminConfigurationCreate = async (configurationRequest: ConfigurationRequest, options?: Parameters<typeof customFetch>[1]): Promise<Configuration> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Configuration>(getAdminConfigurationCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(configurationRequest)
  }
);}





export const getAdminConfigurationCreateMutationKey = () => ['adminConfigurationCreate'] as const;

export const getAdminConfigurationCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminConfigurationCreate>>, TError,AdminConfigurationCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminConfigurationCreate>>, TError,AdminConfigurationCreateMutationVariables, TContext> => {

const mutationKey = getAdminConfigurationCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminConfigurationCreate>>, AdminConfigurationCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminConfigurationCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminConfigurationCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminConfigurationCreate>>>
    export type AdminConfigurationCreateMutationBody = ConfigurationRequest
    export type AdminConfigurationCreateMutationError = void
    export type AdminConfigurationCreateMutationVariables = {data: ConfigurationRequest}

    export const useAdminConfigurationCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminConfigurationCreate>>, TError,AdminConfigurationCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminConfigurationCreate>>,
        TError,
        AdminConfigurationCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminConfigurationCreateMutationOptions(options), queryClient);
    }
    export const getAdminConfigurationRetrieveUrl = (id: number,) => {




  return `/api/admin/configuration/${id}/`
}

/**
 * Configuration objects that are used to set various GigPro API system state parameters.
 */
export const adminConfigurationRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<Configuration> => {

  return customFetch<Configuration>(getAdminConfigurationRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminConfigurationRetrieveQueryKey = (id: number,) => {
    return [
    `/api/admin/configuration/${id}/`
    ] as const;
    }


export const getAdminConfigurationRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminConfigurationRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminConfigurationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminConfigurationRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminConfigurationRetrieve>>> = ({ signal }) => adminConfigurationRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminConfigurationRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminConfigurationRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminConfigurationRetrieve>>>
export type AdminConfigurationRetrieveQueryError = void


export function useAdminConfigurationRetrieve<TData = Awaited<ReturnType<typeof adminConfigurationRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminConfigurationRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminConfigurationRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminConfigurationRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminConfigurationRetrieve<TData = Awaited<ReturnType<typeof adminConfigurationRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminConfigurationRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminConfigurationRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminConfigurationRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminConfigurationRetrieve<TData = Awaited<ReturnType<typeof adminConfigurationRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminConfigurationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminConfigurationRetrieve<TData = Awaited<ReturnType<typeof adminConfigurationRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminConfigurationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminConfigurationRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminConfigurationUpdateUrl = (id: number,) => {




  return `/api/admin/configuration/${id}/`
}

/**
 * Configuration objects that are used to set various GigPro API system state parameters.
 */
export const adminConfigurationUpdate = async (id: number,
    configurationRequest: ConfigurationRequest, options?: Parameters<typeof customFetch>[1]): Promise<Configuration> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Configuration>(getAdminConfigurationUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(configurationRequest)
  }
);}





export const getAdminConfigurationUpdateMutationKey = () => ['adminConfigurationUpdate'] as const;

export const getAdminConfigurationUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminConfigurationUpdate>>, TError,AdminConfigurationUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminConfigurationUpdate>>, TError,AdminConfigurationUpdateMutationVariables, TContext> => {

const mutationKey = getAdminConfigurationUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminConfigurationUpdate>>, AdminConfigurationUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  adminConfigurationUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminConfigurationUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminConfigurationUpdate>>>
    export type AdminConfigurationUpdateMutationBody = ConfigurationRequest
    export type AdminConfigurationUpdateMutationError = void
    export type AdminConfigurationUpdateMutationVariables = {id: number;data: ConfigurationRequest}

    export const useAdminConfigurationUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminConfigurationUpdate>>, TError,AdminConfigurationUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminConfigurationUpdate>>,
        TError,
        AdminConfigurationUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminConfigurationUpdateMutationOptions(options), queryClient);
    }
    export const getAdminConfigurationPartialUpdateUrl = (id: number,) => {




  return `/api/admin/configuration/${id}/`
}

/**
 * Configuration objects that are used to set various GigPro API system state parameters.
 */
export const adminConfigurationPartialUpdate = async (id: number,
    patchedConfigurationRequest?: PatchedConfigurationRequest, options?: Parameters<typeof customFetch>[1]): Promise<Configuration> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Configuration>(getAdminConfigurationPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedConfigurationRequest)
  }
);}





export const getAdminConfigurationPartialUpdateMutationKey = () => ['adminConfigurationPartialUpdate'] as const;

export const getAdminConfigurationPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminConfigurationPartialUpdate>>, TError,AdminConfigurationPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminConfigurationPartialUpdate>>, TError,AdminConfigurationPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminConfigurationPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminConfigurationPartialUpdate>>, AdminConfigurationPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  adminConfigurationPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminConfigurationPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminConfigurationPartialUpdate>>>
    export type AdminConfigurationPartialUpdateMutationBody = PatchedConfigurationRequest | undefined
    export type AdminConfigurationPartialUpdateMutationError = void
    export type AdminConfigurationPartialUpdateMutationVariables = {id: number;data?: PatchedConfigurationRequest}

    export const useAdminConfigurationPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminConfigurationPartialUpdate>>, TError,AdminConfigurationPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminConfigurationPartialUpdate>>,
        TError,
        AdminConfigurationPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminConfigurationPartialUpdateMutationOptions(options), queryClient);
    }
    export const getAdminConfigurationDestroyUrl = (id: number,) => {




  return `/api/admin/configuration/${id}/`
}

/**
 * Configuration objects that are used to set various GigPro API system state parameters.
 */
export const adminConfigurationDestroy = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getAdminConfigurationDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminConfigurationDestroyMutationKey = () => ['adminConfigurationDestroy'] as const;

export const getAdminConfigurationDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminConfigurationDestroy>>, TError,AdminConfigurationDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminConfigurationDestroy>>, TError,AdminConfigurationDestroyMutationVariables, TContext> => {

const mutationKey = getAdminConfigurationDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminConfigurationDestroy>>, AdminConfigurationDestroyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  adminConfigurationDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminConfigurationDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminConfigurationDestroy>>>

    export type AdminConfigurationDestroyMutationError = void
    export type AdminConfigurationDestroyMutationVariables = {id: number}

    export const useAdminConfigurationDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminConfigurationDestroy>>, TError,AdminConfigurationDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminConfigurationDestroy>>,
        TError,
        AdminConfigurationDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminConfigurationDestroyMutationOptions(options), queryClient);
    }
    export const getAdminCouponsListUrl = (params?: AdminCouponsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/coupons/?${stringifiedParams}` : `/api/admin/coupons/`
}

/**
 * A Credit (Coupon) represents an amount of money to be applied to a location during a payment.
 *
 * This API is designed for gigpro admins to allow CRU of coupon for businesses.
 */
export const adminCouponsList = async (params?: AdminCouponsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedCreditList> => {

  return customFetch<PaginatedCreditList>(getAdminCouponsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCouponsListInfiniteQueryKey = (params?: AdminCouponsListParams,) => {
    return [
    'infinite', `/api/admin/coupons/`, ...(params ? [params] : [])
    ] as const;
    }

export const getAdminCouponsListQueryKey = (params?: AdminCouponsListParams,) => {
    return [
    `/api/admin/coupons/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminCouponsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof adminCouponsList>>, AdminCouponsListParams['page']>, TError = void>(params?: AdminCouponsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminCouponsList>>, TError, TData, QueryKey, AdminCouponsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCouponsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCouponsList>>, QueryKey, AdminCouponsListParams['page']> = ({ signal, pageParam }) => adminCouponsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminCouponsList>>, TError, TData, QueryKey, AdminCouponsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCouponsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminCouponsList>>>
export type AdminCouponsListInfiniteQueryError = void


export function useAdminCouponsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminCouponsList>>, AdminCouponsListParams['page']>, TError = void>(
 params: undefined |  AdminCouponsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminCouponsList>>, TError, TData, QueryKey, AdminCouponsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCouponsList>>,
          TError,
          Awaited<ReturnType<typeof adminCouponsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCouponsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminCouponsList>>, AdminCouponsListParams['page']>, TError = void>(
 params?: AdminCouponsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminCouponsList>>, TError, TData, QueryKey, AdminCouponsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCouponsList>>,
          TError,
          Awaited<ReturnType<typeof adminCouponsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCouponsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminCouponsList>>, AdminCouponsListParams['page']>, TError = void>(
 params?: AdminCouponsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminCouponsList>>, TError, TData, QueryKey, AdminCouponsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCouponsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminCouponsList>>, AdminCouponsListParams['page']>, TError = void>(
 params?: AdminCouponsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminCouponsList>>, TError, TData, QueryKey, AdminCouponsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCouponsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminCouponsListQueryOptions = <TData = Awaited<ReturnType<typeof adminCouponsList>>, TError = void>(params?: AdminCouponsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouponsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCouponsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCouponsList>>> = ({ signal }) => adminCouponsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCouponsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCouponsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminCouponsList>>>
export type AdminCouponsListQueryError = void


export function useAdminCouponsList<TData = Awaited<ReturnType<typeof adminCouponsList>>, TError = void>(
 params: undefined |  AdminCouponsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouponsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCouponsList>>,
          TError,
          Awaited<ReturnType<typeof adminCouponsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCouponsList<TData = Awaited<ReturnType<typeof adminCouponsList>>, TError = void>(
 params?: AdminCouponsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouponsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCouponsList>>,
          TError,
          Awaited<ReturnType<typeof adminCouponsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCouponsList<TData = Awaited<ReturnType<typeof adminCouponsList>>, TError = void>(
 params?: AdminCouponsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouponsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCouponsList<TData = Awaited<ReturnType<typeof adminCouponsList>>, TError = void>(
 params?: AdminCouponsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouponsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCouponsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminCouponsCreateUrl = () => {




  return `/api/admin/coupons/`
}

/**
 * A Credit (Coupon) represents an amount of money to be applied to a location during a payment.
 *
 * This API is designed for gigpro admins to allow CRU of coupon for businesses.
 */
export const adminCouponsCreate = async (creditRequest: CreditRequest, options?: Parameters<typeof customFetch>[1]): Promise<Credit> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Credit>(getAdminCouponsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(creditRequest)
  }
);}





export const getAdminCouponsCreateMutationKey = () => ['adminCouponsCreate'] as const;

export const getAdminCouponsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCouponsCreate>>, TError,AdminCouponsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCouponsCreate>>, TError,AdminCouponsCreateMutationVariables, TContext> => {

const mutationKey = getAdminCouponsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCouponsCreate>>, AdminCouponsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminCouponsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCouponsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCouponsCreate>>>
    export type AdminCouponsCreateMutationBody = CreditRequest
    export type AdminCouponsCreateMutationError = void
    export type AdminCouponsCreateMutationVariables = {data: CreditRequest}

    export const useAdminCouponsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCouponsCreate>>, TError,AdminCouponsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCouponsCreate>>,
        TError,
        AdminCouponsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCouponsCreateMutationOptions(options), queryClient);
    }
    export const getAdminCouponsRetrieveUrl = (id: number,) => {




  return `/api/admin/coupons/${id}/`
}

/**
 * A Credit (Coupon) represents an amount of money to be applied to a location during a payment.
 *
 * This API is designed for gigpro admins to allow CRU of coupon for businesses.
 */
export const adminCouponsRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<Credit> => {

  return customFetch<Credit>(getAdminCouponsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCouponsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/admin/coupons/${id}/`
    ] as const;
    }


export const getAdminCouponsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminCouponsRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouponsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCouponsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCouponsRetrieve>>> = ({ signal }) => adminCouponsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCouponsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCouponsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminCouponsRetrieve>>>
export type AdminCouponsRetrieveQueryError = void


export function useAdminCouponsRetrieve<TData = Awaited<ReturnType<typeof adminCouponsRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouponsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCouponsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCouponsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCouponsRetrieve<TData = Awaited<ReturnType<typeof adminCouponsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouponsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCouponsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCouponsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCouponsRetrieve<TData = Awaited<ReturnType<typeof adminCouponsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouponsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCouponsRetrieve<TData = Awaited<ReturnType<typeof adminCouponsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouponsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCouponsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminCouponsUpdateUrl = (id: number,) => {




  return `/api/admin/coupons/${id}/`
}

/**
 * A Credit (Coupon) represents an amount of money to be applied to a location during a payment.
 *
 * This API is designed for gigpro admins to allow CRU of coupon for businesses.
 */
export const adminCouponsUpdate = async (id: number,
    updateCreditRequest: UpdateCreditRequest, options?: Parameters<typeof customFetch>[1]): Promise<UpdateCredit> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<UpdateCredit>(getAdminCouponsUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateCreditRequest)
  }
);}





export const getAdminCouponsUpdateMutationKey = () => ['adminCouponsUpdate'] as const;

export const getAdminCouponsUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCouponsUpdate>>, TError,AdminCouponsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCouponsUpdate>>, TError,AdminCouponsUpdateMutationVariables, TContext> => {

const mutationKey = getAdminCouponsUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCouponsUpdate>>, AdminCouponsUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  adminCouponsUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCouponsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCouponsUpdate>>>
    export type AdminCouponsUpdateMutationBody = UpdateCreditRequest
    export type AdminCouponsUpdateMutationError = void
    export type AdminCouponsUpdateMutationVariables = {id: number;data: UpdateCreditRequest}

    export const useAdminCouponsUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCouponsUpdate>>, TError,AdminCouponsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCouponsUpdate>>,
        TError,
        AdminCouponsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCouponsUpdateMutationOptions(options), queryClient);
    }
    export const getAdminCouponsPartialUpdateUrl = (id: number,) => {




  return `/api/admin/coupons/${id}/`
}

/**
 * A Credit (Coupon) represents an amount of money to be applied to a location during a payment.
 *
 * This API is designed for gigpro admins to allow CRU of coupon for businesses.
 */
export const adminCouponsPartialUpdate = async (id: number,
    patchedCreditRequest?: PatchedCreditRequest, options?: Parameters<typeof customFetch>[1]): Promise<Credit> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Credit>(getAdminCouponsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedCreditRequest)
  }
);}





export const getAdminCouponsPartialUpdateMutationKey = () => ['adminCouponsPartialUpdate'] as const;

export const getAdminCouponsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCouponsPartialUpdate>>, TError,AdminCouponsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCouponsPartialUpdate>>, TError,AdminCouponsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminCouponsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCouponsPartialUpdate>>, AdminCouponsPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  adminCouponsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCouponsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCouponsPartialUpdate>>>
    export type AdminCouponsPartialUpdateMutationBody = PatchedCreditRequest | undefined
    export type AdminCouponsPartialUpdateMutationError = void
    export type AdminCouponsPartialUpdateMutationVariables = {id: number;data?: PatchedCreditRequest}

    export const useAdminCouponsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCouponsPartialUpdate>>, TError,AdminCouponsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCouponsPartialUpdate>>,
        TError,
        AdminCouponsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCouponsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getAdminGigApplicationsListUrl = (params?: AdminGigApplicationsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/gig-applications/?${stringifiedParams}` : `/api/admin/gig-applications/`
}

export const adminGigApplicationsList = async (params?: AdminGigApplicationsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedAdminGigApplicationList> => {

  return customFetch<PaginatedAdminGigApplicationList>(getAdminGigApplicationsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGigApplicationsListInfiniteQueryKey = (params?: AdminGigApplicationsListParams,) => {
    return [
    'infinite', `/api/admin/gig-applications/`, ...(params ? [params] : [])
    ] as const;
    }

export const getAdminGigApplicationsListQueryKey = (params?: AdminGigApplicationsListParams,) => {
    return [
    `/api/admin/gig-applications/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminGigApplicationsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof adminGigApplicationsList>>, AdminGigApplicationsListParams['page']>, TError = void>(params?: AdminGigApplicationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminGigApplicationsList>>, TError, TData, QueryKey, AdminGigApplicationsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGigApplicationsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGigApplicationsList>>, QueryKey, AdminGigApplicationsListParams['page']> = ({ signal, pageParam }) => adminGigApplicationsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminGigApplicationsList>>, TError, TData, QueryKey, AdminGigApplicationsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGigApplicationsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminGigApplicationsList>>>
export type AdminGigApplicationsListInfiniteQueryError = void


export function useAdminGigApplicationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminGigApplicationsList>>, AdminGigApplicationsListParams['page']>, TError = void>(
 params: undefined |  AdminGigApplicationsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminGigApplicationsList>>, TError, TData, QueryKey, AdminGigApplicationsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGigApplicationsList>>,
          TError,
          Awaited<ReturnType<typeof adminGigApplicationsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGigApplicationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminGigApplicationsList>>, AdminGigApplicationsListParams['page']>, TError = void>(
 params?: AdminGigApplicationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminGigApplicationsList>>, TError, TData, QueryKey, AdminGigApplicationsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGigApplicationsList>>,
          TError,
          Awaited<ReturnType<typeof adminGigApplicationsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGigApplicationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminGigApplicationsList>>, AdminGigApplicationsListParams['page']>, TError = void>(
 params?: AdminGigApplicationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminGigApplicationsList>>, TError, TData, QueryKey, AdminGigApplicationsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminGigApplicationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminGigApplicationsList>>, AdminGigApplicationsListParams['page']>, TError = void>(
 params?: AdminGigApplicationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminGigApplicationsList>>, TError, TData, QueryKey, AdminGigApplicationsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGigApplicationsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminGigApplicationsListQueryOptions = <TData = Awaited<ReturnType<typeof adminGigApplicationsList>>, TError = void>(params?: AdminGigApplicationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigApplicationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGigApplicationsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGigApplicationsList>>> = ({ signal }) => adminGigApplicationsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGigApplicationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGigApplicationsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminGigApplicationsList>>>
export type AdminGigApplicationsListQueryError = void


export function useAdminGigApplicationsList<TData = Awaited<ReturnType<typeof adminGigApplicationsList>>, TError = void>(
 params: undefined |  AdminGigApplicationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigApplicationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGigApplicationsList>>,
          TError,
          Awaited<ReturnType<typeof adminGigApplicationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGigApplicationsList<TData = Awaited<ReturnType<typeof adminGigApplicationsList>>, TError = void>(
 params?: AdminGigApplicationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigApplicationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGigApplicationsList>>,
          TError,
          Awaited<ReturnType<typeof adminGigApplicationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGigApplicationsList<TData = Awaited<ReturnType<typeof adminGigApplicationsList>>, TError = void>(
 params?: AdminGigApplicationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigApplicationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminGigApplicationsList<TData = Awaited<ReturnType<typeof adminGigApplicationsList>>, TError = void>(
 params?: AdminGigApplicationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigApplicationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGigApplicationsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminGigApplicationsRetrieveUrl = (id: number,) => {




  return `/api/admin/gig-applications/${id}/`
}

export const adminGigApplicationsRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<AdminGigApplication> => {

  return customFetch<AdminGigApplication>(getAdminGigApplicationsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGigApplicationsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/admin/gig-applications/${id}/`
    ] as const;
    }


export const getAdminGigApplicationsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminGigApplicationsRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigApplicationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGigApplicationsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGigApplicationsRetrieve>>> = ({ signal }) => adminGigApplicationsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGigApplicationsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGigApplicationsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminGigApplicationsRetrieve>>>
export type AdminGigApplicationsRetrieveQueryError = void


export function useAdminGigApplicationsRetrieve<TData = Awaited<ReturnType<typeof adminGigApplicationsRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigApplicationsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGigApplicationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminGigApplicationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGigApplicationsRetrieve<TData = Awaited<ReturnType<typeof adminGigApplicationsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigApplicationsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGigApplicationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminGigApplicationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGigApplicationsRetrieve<TData = Awaited<ReturnType<typeof adminGigApplicationsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigApplicationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminGigApplicationsRetrieve<TData = Awaited<ReturnType<typeof adminGigApplicationsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigApplicationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGigApplicationsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminGigApplicationsUpdateUrl = (id: number,) => {




  return `/api/admin/gig-applications/${id}/`
}

export const adminGigApplicationsUpdate = async (id: number,
    adminGigApplicationCancellationReversalRequest: AdminGigApplicationCancellationReversalRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminGigApplicationCancellationReversal> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminGigApplicationCancellationReversal>(getAdminGigApplicationsUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminGigApplicationCancellationReversalRequest)
  }
);}





export const getAdminGigApplicationsUpdateMutationKey = () => ['adminGigApplicationsUpdate'] as const;

export const getAdminGigApplicationsUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminGigApplicationsUpdate>>, TError,AdminGigApplicationsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminGigApplicationsUpdate>>, TError,AdminGigApplicationsUpdateMutationVariables, TContext> => {

const mutationKey = getAdminGigApplicationsUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminGigApplicationsUpdate>>, AdminGigApplicationsUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  adminGigApplicationsUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminGigApplicationsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminGigApplicationsUpdate>>>
    export type AdminGigApplicationsUpdateMutationBody = AdminGigApplicationCancellationReversalRequest
    export type AdminGigApplicationsUpdateMutationError = void
    export type AdminGigApplicationsUpdateMutationVariables = {id: number;data: AdminGigApplicationCancellationReversalRequest}

    export const useAdminGigApplicationsUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminGigApplicationsUpdate>>, TError,AdminGigApplicationsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminGigApplicationsUpdate>>,
        TError,
        AdminGigApplicationsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminGigApplicationsUpdateMutationOptions(options), queryClient);
    }
    export const getAdminGigApplicationsPartialUpdateUrl = (id: number,) => {




  return `/api/admin/gig-applications/${id}/`
}

export const adminGigApplicationsPartialUpdate = async (id: number,
    patchedAdminGigApplicationSelectOrConfirmProRequest?: PatchedAdminGigApplicationSelectOrConfirmProRequest, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<void>(getAdminGigApplicationsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedAdminGigApplicationSelectOrConfirmProRequest)
  }
);}





export const getAdminGigApplicationsPartialUpdateMutationKey = () => ['adminGigApplicationsPartialUpdate'] as const;

export const getAdminGigApplicationsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminGigApplicationsPartialUpdate>>, TError,AdminGigApplicationsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminGigApplicationsPartialUpdate>>, TError,AdminGigApplicationsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminGigApplicationsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminGigApplicationsPartialUpdate>>, AdminGigApplicationsPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  adminGigApplicationsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminGigApplicationsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminGigApplicationsPartialUpdate>>>
    export type AdminGigApplicationsPartialUpdateMutationBody = PatchedAdminGigApplicationSelectOrConfirmProRequest | undefined
    export type AdminGigApplicationsPartialUpdateMutationError = void
    export type AdminGigApplicationsPartialUpdateMutationVariables = {id: number;data?: PatchedAdminGigApplicationSelectOrConfirmProRequest}

    export const useAdminGigApplicationsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminGigApplicationsPartialUpdate>>, TError,AdminGigApplicationsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminGigApplicationsPartialUpdate>>,
        TError,
        AdminGigApplicationsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminGigApplicationsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getAdminGigsScheduleChangesListUrl = (gigId: number,
    params?: AdminGigsScheduleChangesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/gigs/${gigId}/schedule-changes/?${stringifiedParams}` : `/api/admin/gigs/${gigId}/schedule-changes/`
}

/**
 * A shift's Chicago Fair Workweek schedule-change ledger, oldest first (WORK-9617).
 *
 * Every ``ScheduleChangeEvent`` recorded for the gig, with what changed, who changed it and the ad hoc
 * payment that settled it, if any. A gig nothing was recorded for, or that does not exist, is ``[]``.
 */
export const adminGigsScheduleChangesList = async (gigId: number,
    params?: AdminGigsScheduleChangesListParams, options?: Parameters<typeof customFetch>[1]): Promise<AdminScheduleChangeEvent[]> => {

  return customFetch<AdminScheduleChangeEvent[]>(getAdminGigsScheduleChangesListUrl(gigId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGigsScheduleChangesListQueryKey = (gigId: number,
    params?: AdminGigsScheduleChangesListParams,) => {
    return [
    `/api/admin/gigs/${gigId}/schedule-changes/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminGigsScheduleChangesListQueryOptions = <TData = Awaited<ReturnType<typeof adminGigsScheduleChangesList>>, TError = void>(gigId: number,
    params?: AdminGigsScheduleChangesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsScheduleChangesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGigsScheduleChangesListQueryKey(gigId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGigsScheduleChangesList>>> = ({ signal }) => adminGigsScheduleChangesList(gigId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: gigId !== null && gigId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGigsScheduleChangesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGigsScheduleChangesListQueryResult = NonNullable<Awaited<ReturnType<typeof adminGigsScheduleChangesList>>>
export type AdminGigsScheduleChangesListQueryError = void


export function useAdminGigsScheduleChangesList<TData = Awaited<ReturnType<typeof adminGigsScheduleChangesList>>, TError = void>(
 gigId: number,
    params: undefined |  AdminGigsScheduleChangesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsScheduleChangesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGigsScheduleChangesList>>,
          TError,
          Awaited<ReturnType<typeof adminGigsScheduleChangesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGigsScheduleChangesList<TData = Awaited<ReturnType<typeof adminGigsScheduleChangesList>>, TError = void>(
 gigId: number,
    params?: AdminGigsScheduleChangesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsScheduleChangesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGigsScheduleChangesList>>,
          TError,
          Awaited<ReturnType<typeof adminGigsScheduleChangesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGigsScheduleChangesList<TData = Awaited<ReturnType<typeof adminGigsScheduleChangesList>>, TError = void>(
 gigId: number,
    params?: AdminGigsScheduleChangesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsScheduleChangesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminGigsScheduleChangesList<TData = Awaited<ReturnType<typeof adminGigsScheduleChangesList>>, TError = void>(
 gigId: number,
    params?: AdminGigsScheduleChangesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsScheduleChangesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGigsScheduleChangesListQueryOptions(gigId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminGigsterProfilesListUrl = (params?: AdminGigsterProfilesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/gigster-profiles/?${stringifiedParams}` : `/api/admin/gigster-profiles/`
}

/**
 * A GigsterProfile contains details, some public and some private, regarding a Pro.
 *
 * This API is designed for GigPro admins to query the list of Pros and mark as verified
 */
export const adminGigsterProfilesList = async (params?: AdminGigsterProfilesListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedProReadonlyList> => {

  return customFetch<PaginatedProReadonlyList>(getAdminGigsterProfilesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGigsterProfilesListInfiniteQueryKey = (params?: AdminGigsterProfilesListParams,) => {
    return [
    'infinite', `/api/admin/gigster-profiles/`, ...(params ? [params] : [])
    ] as const;
    }

export const getAdminGigsterProfilesListQueryKey = (params?: AdminGigsterProfilesListParams,) => {
    return [
    `/api/admin/gigster-profiles/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminGigsterProfilesListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof adminGigsterProfilesList>>, AdminGigsterProfilesListParams['page']>, TError = void>(params?: AdminGigsterProfilesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesList>>, TError, TData, QueryKey, AdminGigsterProfilesListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGigsterProfilesListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGigsterProfilesList>>, QueryKey, AdminGigsterProfilesListParams['page']> = ({ signal, pageParam }) => adminGigsterProfilesList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesList>>, TError, TData, QueryKey, AdminGigsterProfilesListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGigsterProfilesListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminGigsterProfilesList>>>
export type AdminGigsterProfilesListInfiniteQueryError = void


export function useAdminGigsterProfilesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminGigsterProfilesList>>, AdminGigsterProfilesListParams['page']>, TError = void>(
 params: undefined |  AdminGigsterProfilesListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesList>>, TError, TData, QueryKey, AdminGigsterProfilesListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGigsterProfilesList>>,
          TError,
          Awaited<ReturnType<typeof adminGigsterProfilesList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGigsterProfilesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminGigsterProfilesList>>, AdminGigsterProfilesListParams['page']>, TError = void>(
 params?: AdminGigsterProfilesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesList>>, TError, TData, QueryKey, AdminGigsterProfilesListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGigsterProfilesList>>,
          TError,
          Awaited<ReturnType<typeof adminGigsterProfilesList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGigsterProfilesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminGigsterProfilesList>>, AdminGigsterProfilesListParams['page']>, TError = void>(
 params?: AdminGigsterProfilesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesList>>, TError, TData, QueryKey, AdminGigsterProfilesListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminGigsterProfilesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminGigsterProfilesList>>, AdminGigsterProfilesListParams['page']>, TError = void>(
 params?: AdminGigsterProfilesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesList>>, TError, TData, QueryKey, AdminGigsterProfilesListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGigsterProfilesListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminGigsterProfilesListQueryOptions = <TData = Awaited<ReturnType<typeof adminGigsterProfilesList>>, TError = void>(params?: AdminGigsterProfilesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGigsterProfilesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGigsterProfilesList>>> = ({ signal }) => adminGigsterProfilesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGigsterProfilesListQueryResult = NonNullable<Awaited<ReturnType<typeof adminGigsterProfilesList>>>
export type AdminGigsterProfilesListQueryError = void


export function useAdminGigsterProfilesList<TData = Awaited<ReturnType<typeof adminGigsterProfilesList>>, TError = void>(
 params: undefined |  AdminGigsterProfilesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGigsterProfilesList>>,
          TError,
          Awaited<ReturnType<typeof adminGigsterProfilesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGigsterProfilesList<TData = Awaited<ReturnType<typeof adminGigsterProfilesList>>, TError = void>(
 params?: AdminGigsterProfilesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGigsterProfilesList>>,
          TError,
          Awaited<ReturnType<typeof adminGigsterProfilesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGigsterProfilesList<TData = Awaited<ReturnType<typeof adminGigsterProfilesList>>, TError = void>(
 params?: AdminGigsterProfilesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminGigsterProfilesList<TData = Awaited<ReturnType<typeof adminGigsterProfilesList>>, TError = void>(
 params?: AdminGigsterProfilesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGigsterProfilesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminGigsterProfilesRetrieveUrl = (userId: number,) => {




  return `/api/admin/gigster-profiles/${userId}/`
}

/**
 * A GigsterProfile contains details, some public and some private, regarding a Pro.
 *
 * This API is designed for GigPro admins to query the list of Pros and mark as verified
 */
export const adminGigsterProfilesRetrieve = async (userId: number, options?: Parameters<typeof customFetch>[1]): Promise<unknown> => {

  return customFetch<unknown>(getAdminGigsterProfilesRetrieveUrl(userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGigsterProfilesRetrieveQueryKey = (userId: number,) => {
    return [
    `/api/admin/gigster-profiles/${userId}/`
    ] as const;
    }


export const getAdminGigsterProfilesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminGigsterProfilesRetrieve>>, TError = void>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGigsterProfilesRetrieveQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGigsterProfilesRetrieve>>> = ({ signal }) => adminGigsterProfilesRetrieve(userId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGigsterProfilesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminGigsterProfilesRetrieve>>>
export type AdminGigsterProfilesRetrieveQueryError = void


export function useAdminGigsterProfilesRetrieve<TData = Awaited<ReturnType<typeof adminGigsterProfilesRetrieve>>, TError = void>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGigsterProfilesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminGigsterProfilesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGigsterProfilesRetrieve<TData = Awaited<ReturnType<typeof adminGigsterProfilesRetrieve>>, TError = void>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGigsterProfilesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminGigsterProfilesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGigsterProfilesRetrieve<TData = Awaited<ReturnType<typeof adminGigsterProfilesRetrieve>>, TError = void>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminGigsterProfilesRetrieve<TData = Awaited<ReturnType<typeof adminGigsterProfilesRetrieve>>, TError = void>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGigsterProfilesRetrieveQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminGigsterProfilesSectionRetrieveUrl = (userId: number,
    section: 'about_preferences' | 'experience' | 'header' | 'review_stats',) => {




  return `/api/admin/gigster-profiles/${userId}/${section}/`
}

/**
 * A GigsterProfile contains details, some public and some private, regarding a Pro.
 *
 * This API is designed for GigPro admins to query the list of Pros and mark as verified
 * @deprecated
 */
export const adminGigsterProfilesSectionRetrieve = async (userId: number,
    section: 'about_preferences' | 'experience' | 'header' | 'review_stats', options?: Parameters<typeof customFetch>[1]): Promise<ProProfileSectionResponse> => {

  return customFetch<ProProfileSectionResponse>(getAdminGigsterProfilesSectionRetrieveUrl(userId,section),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGigsterProfilesSectionRetrieveQueryKey = (userId: number,
    section: 'about_preferences' | 'experience' | 'header' | 'review_stats',) => {
    return [
    `/api/admin/gigster-profiles/${userId}/${section}/`
    ] as const;
    }


export const getAdminGigsterProfilesSectionRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminGigsterProfilesSectionRetrieve>>, TError = void>(userId: number,
    section: 'about_preferences' | 'experience' | 'header' | 'review_stats', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesSectionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGigsterProfilesSectionRetrieveQueryKey(userId,section);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGigsterProfilesSectionRetrieve>>> = ({ signal }) => adminGigsterProfilesSectionRetrieve(userId,section, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined && section !== null && section !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesSectionRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGigsterProfilesSectionRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminGigsterProfilesSectionRetrieve>>>
export type AdminGigsterProfilesSectionRetrieveQueryError = void


export function useAdminGigsterProfilesSectionRetrieve<TData = Awaited<ReturnType<typeof adminGigsterProfilesSectionRetrieve>>, TError = void>(
 userId: number,
    section: 'about_preferences' | 'experience' | 'header' | 'review_stats', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesSectionRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGigsterProfilesSectionRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminGigsterProfilesSectionRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGigsterProfilesSectionRetrieve<TData = Awaited<ReturnType<typeof adminGigsterProfilesSectionRetrieve>>, TError = void>(
 userId: number,
    section: 'about_preferences' | 'experience' | 'header' | 'review_stats', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesSectionRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGigsterProfilesSectionRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminGigsterProfilesSectionRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGigsterProfilesSectionRetrieve<TData = Awaited<ReturnType<typeof adminGigsterProfilesSectionRetrieve>>, TError = void>(
 userId: number,
    section: 'about_preferences' | 'experience' | 'header' | 'review_stats', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesSectionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useAdminGigsterProfilesSectionRetrieve<TData = Awaited<ReturnType<typeof adminGigsterProfilesSectionRetrieve>>, TError = void>(
 userId: number,
    section: 'about_preferences' | 'experience' | 'header' | 'review_stats', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesSectionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGigsterProfilesSectionRetrieveQueryOptions(userId,section,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminGigsterProfilesAiInterviewInvitesRetrieveUrl = (userId: number,) => {




  return `/api/admin/gigster-profiles/${userId}/ai-interview-invites/`
}

/**
 * Read the pro's AI onboarding interview state (drives the CRM chip).
 */
export const adminGigsterProfilesAiInterviewInvitesRetrieve = async (userId: number, options?: Parameters<typeof customFetch>[1]): Promise<AiInterviewInviteResponse> => {

  return customFetch<AiInterviewInviteResponse>(getAdminGigsterProfilesAiInterviewInvitesRetrieveUrl(userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGigsterProfilesAiInterviewInvitesRetrieveQueryKey = (userId: number,) => {
    return [
    `/api/admin/gigster-profiles/${userId}/ai-interview-invites/`
    ] as const;
    }


export const getAdminGigsterProfilesAiInterviewInvitesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminGigsterProfilesAiInterviewInvitesRetrieve>>, TError = void>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesAiInterviewInvitesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGigsterProfilesAiInterviewInvitesRetrieveQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGigsterProfilesAiInterviewInvitesRetrieve>>> = ({ signal }) => adminGigsterProfilesAiInterviewInvitesRetrieve(userId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesAiInterviewInvitesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGigsterProfilesAiInterviewInvitesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminGigsterProfilesAiInterviewInvitesRetrieve>>>
export type AdminGigsterProfilesAiInterviewInvitesRetrieveQueryError = void


export function useAdminGigsterProfilesAiInterviewInvitesRetrieve<TData = Awaited<ReturnType<typeof adminGigsterProfilesAiInterviewInvitesRetrieve>>, TError = void>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesAiInterviewInvitesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGigsterProfilesAiInterviewInvitesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminGigsterProfilesAiInterviewInvitesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGigsterProfilesAiInterviewInvitesRetrieve<TData = Awaited<ReturnType<typeof adminGigsterProfilesAiInterviewInvitesRetrieve>>, TError = void>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesAiInterviewInvitesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGigsterProfilesAiInterviewInvitesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminGigsterProfilesAiInterviewInvitesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGigsterProfilesAiInterviewInvitesRetrieve<TData = Awaited<ReturnType<typeof adminGigsterProfilesAiInterviewInvitesRetrieve>>, TError = void>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesAiInterviewInvitesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminGigsterProfilesAiInterviewInvitesRetrieve<TData = Awaited<ReturnType<typeof adminGigsterProfilesAiInterviewInvitesRetrieve>>, TError = void>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesAiInterviewInvitesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGigsterProfilesAiInterviewInvitesRetrieveQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminGigsterProfilesAiInterviewInvitesCreateUrl = (userId: number,) => {




  return `/api/admin/gigster-profiles/${userId}/ai-interview-invites/`
}

/**
 * Mint + SMS/push a fresh AI onboarding interview invite to the pro.
 */
export const adminGigsterProfilesAiInterviewInvitesCreate = async (userId: number,
    aiInterviewInviteRequestRequest?: AiInterviewInviteRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<AiInterviewInviteResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AiInterviewInviteResponse>(getAdminGigsterProfilesAiInterviewInvitesCreateUrl(userId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(aiInterviewInviteRequestRequest)
  }
);}





export const getAdminGigsterProfilesAiInterviewInvitesCreateMutationKey = () => ['adminGigsterProfilesAiInterviewInvitesCreate'] as const;

export const getAdminGigsterProfilesAiInterviewInvitesCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminGigsterProfilesAiInterviewInvitesCreate>>, TError,AdminGigsterProfilesAiInterviewInvitesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminGigsterProfilesAiInterviewInvitesCreate>>, TError,AdminGigsterProfilesAiInterviewInvitesCreateMutationVariables, TContext> => {

const mutationKey = getAdminGigsterProfilesAiInterviewInvitesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminGigsterProfilesAiInterviewInvitesCreate>>, AdminGigsterProfilesAiInterviewInvitesCreateMutationVariables> = (props) => {
          const {userId,data} = props ?? {};

          return  adminGigsterProfilesAiInterviewInvitesCreate(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminGigsterProfilesAiInterviewInvitesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminGigsterProfilesAiInterviewInvitesCreate>>>
    export type AdminGigsterProfilesAiInterviewInvitesCreateMutationBody = AiInterviewInviteRequestRequest | undefined
    export type AdminGigsterProfilesAiInterviewInvitesCreateMutationError = void
    export type AdminGigsterProfilesAiInterviewInvitesCreateMutationVariables = {userId: number;data?: AiInterviewInviteRequestRequest}

    export const useAdminGigsterProfilesAiInterviewInvitesCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminGigsterProfilesAiInterviewInvitesCreate>>, TError,AdminGigsterProfilesAiInterviewInvitesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminGigsterProfilesAiInterviewInvitesCreate>>,
        TError,
        AdminGigsterProfilesAiInterviewInvitesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminGigsterProfilesAiInterviewInvitesCreateMutationOptions(options), queryClient);
    }
    export const getAdminGigsterProfilesOnboardingStepOverridesCreateUrl = (userId: number,) => {




  return `/api/admin/gigster-profiles/${userId}/onboarding-step-overrides/`
}

/**
 * A GigsterProfile contains details, some public and some private, regarding a Pro.
 *
 * This API is designed for GigPro admins to query the list of Pros and mark as verified
 */
export const adminGigsterProfilesOnboardingStepOverridesCreate = async (userId: number,
    onboardingStepOverrideRequest: OnboardingStepOverrideRequest, options?: Parameters<typeof customFetch>[1]): Promise<OnboardingStepOverride> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<OnboardingStepOverride>(getAdminGigsterProfilesOnboardingStepOverridesCreateUrl(userId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(onboardingStepOverrideRequest)
  }
);}





export const getAdminGigsterProfilesOnboardingStepOverridesCreateMutationKey = () => ['adminGigsterProfilesOnboardingStepOverridesCreate'] as const;

export const getAdminGigsterProfilesOnboardingStepOverridesCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminGigsterProfilesOnboardingStepOverridesCreate>>, TError,AdminGigsterProfilesOnboardingStepOverridesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminGigsterProfilesOnboardingStepOverridesCreate>>, TError,AdminGigsterProfilesOnboardingStepOverridesCreateMutationVariables, TContext> => {

const mutationKey = getAdminGigsterProfilesOnboardingStepOverridesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminGigsterProfilesOnboardingStepOverridesCreate>>, AdminGigsterProfilesOnboardingStepOverridesCreateMutationVariables> = (props) => {
          const {userId,data} = props ?? {};

          return  adminGigsterProfilesOnboardingStepOverridesCreate(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminGigsterProfilesOnboardingStepOverridesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminGigsterProfilesOnboardingStepOverridesCreate>>>
    export type AdminGigsterProfilesOnboardingStepOverridesCreateMutationBody = OnboardingStepOverrideRequest
    export type AdminGigsterProfilesOnboardingStepOverridesCreateMutationError = void
    export type AdminGigsterProfilesOnboardingStepOverridesCreateMutationVariables = {userId: number;data: OnboardingStepOverrideRequest}

    export const useAdminGigsterProfilesOnboardingStepOverridesCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminGigsterProfilesOnboardingStepOverridesCreate>>, TError,AdminGigsterProfilesOnboardingStepOverridesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminGigsterProfilesOnboardingStepOverridesCreate>>,
        TError,
        AdminGigsterProfilesOnboardingStepOverridesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminGigsterProfilesOnboardingStepOverridesCreateMutationOptions(options), queryClient);
    }
    export const getAdminGigsterProfilesOnboardingStepOverridesDestroyUrl = (userId: number,
    requirement: string,) => {




  return `/api/admin/gigster-profiles/${userId}/onboarding-step-overrides/${requirement}/`
}

/**
 * A GigsterProfile contains details, some public and some private, regarding a Pro.
 *
 * This API is designed for GigPro admins to query the list of Pros and mark as verified
 */
export const adminGigsterProfilesOnboardingStepOverridesDestroy = async (userId: number,
    requirement: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getAdminGigsterProfilesOnboardingStepOverridesDestroyUrl(userId,requirement),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminGigsterProfilesOnboardingStepOverridesDestroyMutationKey = () => ['adminGigsterProfilesOnboardingStepOverridesDestroy'] as const;

export const getAdminGigsterProfilesOnboardingStepOverridesDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminGigsterProfilesOnboardingStepOverridesDestroy>>, TError,AdminGigsterProfilesOnboardingStepOverridesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminGigsterProfilesOnboardingStepOverridesDestroy>>, TError,AdminGigsterProfilesOnboardingStepOverridesDestroyMutationVariables, TContext> => {

const mutationKey = getAdminGigsterProfilesOnboardingStepOverridesDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminGigsterProfilesOnboardingStepOverridesDestroy>>, AdminGigsterProfilesOnboardingStepOverridesDestroyMutationVariables> = (props) => {
          const {userId,requirement} = props ?? {};

          return  adminGigsterProfilesOnboardingStepOverridesDestroy(userId,requirement,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminGigsterProfilesOnboardingStepOverridesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminGigsterProfilesOnboardingStepOverridesDestroy>>>

    export type AdminGigsterProfilesOnboardingStepOverridesDestroyMutationError = void
    export type AdminGigsterProfilesOnboardingStepOverridesDestroyMutationVariables = {userId: number;requirement: string}

    export const useAdminGigsterProfilesOnboardingStepOverridesDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminGigsterProfilesOnboardingStepOverridesDestroy>>, TError,AdminGigsterProfilesOnboardingStepOverridesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminGigsterProfilesOnboardingStepOverridesDestroy>>,
        TError,
        AdminGigsterProfilesOnboardingStepOverridesDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminGigsterProfilesOnboardingStepOverridesDestroyMutationOptions(options), queryClient);
    }
    export const getAdminGigsterProfilesSickTimeRetrieveUrl = (userId: number,) => {




  return `/api/admin/gigster-profiles/${userId}/sick-time/`
}

/**
 * The pro's Zeal sick balance and their own sick-time requests. Not behind the pro-sick-time flag.
 */
export const adminGigsterProfilesSickTimeRetrieve = async (userId: number, options?: Parameters<typeof customFetch>[1]): Promise<AdminProSickTime> => {

  return customFetch<AdminProSickTime>(getAdminGigsterProfilesSickTimeRetrieveUrl(userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGigsterProfilesSickTimeRetrieveQueryKey = (userId: number,) => {
    return [
    `/api/admin/gigster-profiles/${userId}/sick-time/`
    ] as const;
    }


export const getAdminGigsterProfilesSickTimeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminGigsterProfilesSickTimeRetrieve>>, TError = void>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesSickTimeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGigsterProfilesSickTimeRetrieveQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGigsterProfilesSickTimeRetrieve>>> = ({ signal }) => adminGigsterProfilesSickTimeRetrieve(userId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesSickTimeRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGigsterProfilesSickTimeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminGigsterProfilesSickTimeRetrieve>>>
export type AdminGigsterProfilesSickTimeRetrieveQueryError = void


export function useAdminGigsterProfilesSickTimeRetrieve<TData = Awaited<ReturnType<typeof adminGigsterProfilesSickTimeRetrieve>>, TError = void>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesSickTimeRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGigsterProfilesSickTimeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminGigsterProfilesSickTimeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGigsterProfilesSickTimeRetrieve<TData = Awaited<ReturnType<typeof adminGigsterProfilesSickTimeRetrieve>>, TError = void>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesSickTimeRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGigsterProfilesSickTimeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminGigsterProfilesSickTimeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGigsterProfilesSickTimeRetrieve<TData = Awaited<ReturnType<typeof adminGigsterProfilesSickTimeRetrieve>>, TError = void>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesSickTimeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminGigsterProfilesSickTimeRetrieve<TData = Awaited<ReturnType<typeof adminGigsterProfilesSickTimeRetrieve>>, TError = void>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesSickTimeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGigsterProfilesSickTimeRetrieveQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminGigsterProfilesW2EmploymentStatusRetrieveUrl = (userId: number,) => {




  return `/api/admin/gigster-profiles/${userId}/w2-employment-status/`
}

/**
 * Preview of what terminating the pro would do to their W-2 shifts.
 */
export const adminGigsterProfilesW2EmploymentStatusRetrieve = async (userId: number, options?: Parameters<typeof customFetch>[1]): Promise<W2TerminationImpact> => {

  return customFetch<W2TerminationImpact>(getAdminGigsterProfilesW2EmploymentStatusRetrieveUrl(userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGigsterProfilesW2EmploymentStatusRetrieveQueryKey = (userId: number,) => {
    return [
    `/api/admin/gigster-profiles/${userId}/w2-employment-status/`
    ] as const;
    }


export const getAdminGigsterProfilesW2EmploymentStatusRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminGigsterProfilesW2EmploymentStatusRetrieve>>, TError = void | PermissionDeniedError | NotFoundError>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesW2EmploymentStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGigsterProfilesW2EmploymentStatusRetrieveQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGigsterProfilesW2EmploymentStatusRetrieve>>> = ({ signal }) => adminGigsterProfilesW2EmploymentStatusRetrieve(userId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesW2EmploymentStatusRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGigsterProfilesW2EmploymentStatusRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminGigsterProfilesW2EmploymentStatusRetrieve>>>
export type AdminGigsterProfilesW2EmploymentStatusRetrieveQueryError = void | PermissionDeniedError | NotFoundError


export function useAdminGigsterProfilesW2EmploymentStatusRetrieve<TData = Awaited<ReturnType<typeof adminGigsterProfilesW2EmploymentStatusRetrieve>>, TError = void | PermissionDeniedError | NotFoundError>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesW2EmploymentStatusRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGigsterProfilesW2EmploymentStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminGigsterProfilesW2EmploymentStatusRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGigsterProfilesW2EmploymentStatusRetrieve<TData = Awaited<ReturnType<typeof adminGigsterProfilesW2EmploymentStatusRetrieve>>, TError = void | PermissionDeniedError | NotFoundError>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesW2EmploymentStatusRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGigsterProfilesW2EmploymentStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminGigsterProfilesW2EmploymentStatusRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGigsterProfilesW2EmploymentStatusRetrieve<TData = Awaited<ReturnType<typeof adminGigsterProfilesW2EmploymentStatusRetrieve>>, TError = void | PermissionDeniedError | NotFoundError>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesW2EmploymentStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminGigsterProfilesW2EmploymentStatusRetrieve<TData = Awaited<ReturnType<typeof adminGigsterProfilesW2EmploymentStatusRetrieve>>, TError = void | PermissionDeniedError | NotFoundError>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGigsterProfilesW2EmploymentStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGigsterProfilesW2EmploymentStatusRetrieveQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminGigsterProfilesW2EmploymentStatusCreateUrl = (userId: number,) => {




  return `/api/admin/gigster-profiles/${userId}/w2-employment-status/`
}

/**
 * Terminate or restore the pro's W-2 (Zeal) employment. Terminating cancels and reopens the pro's
 * not-yet-started W-2 shifts; worked and in-progress ones stay assigned and are still paid.
 */
export const adminGigsterProfilesW2EmploymentStatusCreate = async (userId: number,
    w2EmploymentStatusUpdateRequest: W2EmploymentStatusUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<W2EmploymentStatusResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<W2EmploymentStatusResponse>(getAdminGigsterProfilesW2EmploymentStatusCreateUrl(userId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(w2EmploymentStatusUpdateRequest)
  }
);}





export const getAdminGigsterProfilesW2EmploymentStatusCreateMutationKey = () => ['adminGigsterProfilesW2EmploymentStatusCreate'] as const;

export const getAdminGigsterProfilesW2EmploymentStatusCreateMutationOptions = <TError = void | PermissionDeniedError | NotFoundError | ServiceUnavailableError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminGigsterProfilesW2EmploymentStatusCreate>>, TError,AdminGigsterProfilesW2EmploymentStatusCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminGigsterProfilesW2EmploymentStatusCreate>>, TError,AdminGigsterProfilesW2EmploymentStatusCreateMutationVariables, TContext> => {

const mutationKey = getAdminGigsterProfilesW2EmploymentStatusCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminGigsterProfilesW2EmploymentStatusCreate>>, AdminGigsterProfilesW2EmploymentStatusCreateMutationVariables> = (props) => {
          const {userId,data} = props ?? {};

          return  adminGigsterProfilesW2EmploymentStatusCreate(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminGigsterProfilesW2EmploymentStatusCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminGigsterProfilesW2EmploymentStatusCreate>>>
    export type AdminGigsterProfilesW2EmploymentStatusCreateMutationBody = W2EmploymentStatusUpdateRequest
    export type AdminGigsterProfilesW2EmploymentStatusCreateMutationError = void | PermissionDeniedError | NotFoundError | ServiceUnavailableError
    export type AdminGigsterProfilesW2EmploymentStatusCreateMutationVariables = {userId: number;data: W2EmploymentStatusUpdateRequest}

    export const useAdminGigsterProfilesW2EmploymentStatusCreate = <TError = void | PermissionDeniedError | NotFoundError | ServiceUnavailableError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminGigsterProfilesW2EmploymentStatusCreate>>, TError,AdminGigsterProfilesW2EmploymentStatusCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminGigsterProfilesW2EmploymentStatusCreate>>,
        TError,
        AdminGigsterProfilesW2EmploymentStatusCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminGigsterProfilesW2EmploymentStatusCreateMutationOptions(options), queryClient);
    }
    export const getAdminHighDemandSurchargesListUrl = (params: AdminHighDemandSurchargesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/high-demand-surcharges/?${stringifiedParams}` : `/api/admin/high-demand-surcharges/`
}

/**
 * The pro's upcoming shifts with a surcharge, or with one an admin removed, soonest first.
 */
export const adminHighDemandSurchargesList = async (params: AdminHighDemandSurchargesListParams, options?: Parameters<typeof customFetch>[1]): Promise<AdminHighDemandSurcharge[]> => {

  return customFetch<AdminHighDemandSurcharge[]>(getAdminHighDemandSurchargesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminHighDemandSurchargesListQueryKey = (params?: AdminHighDemandSurchargesListParams,) => {
    return [
    `/api/admin/high-demand-surcharges/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminHighDemandSurchargesListQueryOptions = <TData = Awaited<ReturnType<typeof adminHighDemandSurchargesList>>, TError = void>(params: AdminHighDemandSurchargesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminHighDemandSurchargesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminHighDemandSurchargesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminHighDemandSurchargesList>>> = ({ signal }) => adminHighDemandSurchargesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminHighDemandSurchargesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminHighDemandSurchargesListQueryResult = NonNullable<Awaited<ReturnType<typeof adminHighDemandSurchargesList>>>
export type AdminHighDemandSurchargesListQueryError = void


export function useAdminHighDemandSurchargesList<TData = Awaited<ReturnType<typeof adminHighDemandSurchargesList>>, TError = void>(
 params: AdminHighDemandSurchargesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminHighDemandSurchargesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminHighDemandSurchargesList>>,
          TError,
          Awaited<ReturnType<typeof adminHighDemandSurchargesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminHighDemandSurchargesList<TData = Awaited<ReturnType<typeof adminHighDemandSurchargesList>>, TError = void>(
 params: AdminHighDemandSurchargesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminHighDemandSurchargesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminHighDemandSurchargesList>>,
          TError,
          Awaited<ReturnType<typeof adminHighDemandSurchargesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminHighDemandSurchargesList<TData = Awaited<ReturnType<typeof adminHighDemandSurchargesList>>, TError = void>(
 params: AdminHighDemandSurchargesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminHighDemandSurchargesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminHighDemandSurchargesList<TData = Awaited<ReturnType<typeof adminHighDemandSurchargesList>>, TError = void>(
 params: AdminHighDemandSurchargesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminHighDemandSurchargesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminHighDemandSurchargesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminHighDemandSurchargesRemoveCreateUrl = () => {




  return `/api/admin/high-demand-surcharges/remove/`
}

/**
 * Admins removing a pro's High Demand surcharge from upcoming shifts, and reversing it (CORE-7459).
 */
export const adminHighDemandSurchargesRemoveCreate = async (adminHighDemandSurchargeRemoveRequest: AdminHighDemandSurchargeRemoveRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminHighDemandSurchargeRestore> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminHighDemandSurchargeRestore>(getAdminHighDemandSurchargesRemoveCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminHighDemandSurchargeRemoveRequest)
  }
);}





export const getAdminHighDemandSurchargesRemoveCreateMutationKey = () => ['adminHighDemandSurchargesRemoveCreate'] as const;

export const getAdminHighDemandSurchargesRemoveCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminHighDemandSurchargesRemoveCreate>>, TError,AdminHighDemandSurchargesRemoveCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminHighDemandSurchargesRemoveCreate>>, TError,AdminHighDemandSurchargesRemoveCreateMutationVariables, TContext> => {

const mutationKey = getAdminHighDemandSurchargesRemoveCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminHighDemandSurchargesRemoveCreate>>, AdminHighDemandSurchargesRemoveCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminHighDemandSurchargesRemoveCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminHighDemandSurchargesRemoveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminHighDemandSurchargesRemoveCreate>>>
    export type AdminHighDemandSurchargesRemoveCreateMutationBody = AdminHighDemandSurchargeRemoveRequest
    export type AdminHighDemandSurchargesRemoveCreateMutationError = void
    export type AdminHighDemandSurchargesRemoveCreateMutationVariables = {data: AdminHighDemandSurchargeRemoveRequest}

    export const useAdminHighDemandSurchargesRemoveCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminHighDemandSurchargesRemoveCreate>>, TError,AdminHighDemandSurchargesRemoveCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminHighDemandSurchargesRemoveCreate>>,
        TError,
        AdminHighDemandSurchargesRemoveCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminHighDemandSurchargesRemoveCreateMutationOptions(options), queryClient);
    }
    export const getAdminHighDemandSurchargesRestoreCreateUrl = () => {




  return `/api/admin/high-demand-surcharges/restore/`
}

/**
 * Admins removing a pro's High Demand surcharge from upcoming shifts, and reversing it (CORE-7459).
 */
export const adminHighDemandSurchargesRestoreCreate = async (adminHighDemandSurchargeRestoreRequest: AdminHighDemandSurchargeRestoreRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminHighDemandSurchargeRestore> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminHighDemandSurchargeRestore>(getAdminHighDemandSurchargesRestoreCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminHighDemandSurchargeRestoreRequest)
  }
);}





export const getAdminHighDemandSurchargesRestoreCreateMutationKey = () => ['adminHighDemandSurchargesRestoreCreate'] as const;

export const getAdminHighDemandSurchargesRestoreCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminHighDemandSurchargesRestoreCreate>>, TError,AdminHighDemandSurchargesRestoreCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminHighDemandSurchargesRestoreCreate>>, TError,AdminHighDemandSurchargesRestoreCreateMutationVariables, TContext> => {

const mutationKey = getAdminHighDemandSurchargesRestoreCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminHighDemandSurchargesRestoreCreate>>, AdminHighDemandSurchargesRestoreCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminHighDemandSurchargesRestoreCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminHighDemandSurchargesRestoreCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminHighDemandSurchargesRestoreCreate>>>
    export type AdminHighDemandSurchargesRestoreCreateMutationBody = AdminHighDemandSurchargeRestoreRequest
    export type AdminHighDemandSurchargesRestoreCreateMutationError = void
    export type AdminHighDemandSurchargesRestoreCreateMutationVariables = {data: AdminHighDemandSurchargeRestoreRequest}

    export const useAdminHighDemandSurchargesRestoreCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminHighDemandSurchargesRestoreCreate>>, TError,AdminHighDemandSurchargesRestoreCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminHighDemandSurchargesRestoreCreate>>,
        TError,
        AdminHighDemandSurchargesRestoreCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminHighDemandSurchargesRestoreCreateMutationOptions(options), queryClient);
    }
    export const getAdminInvoicingBackfillsListUrl = (params?: AdminInvoicingBackfillsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/invoicing/backfills/?${stringifiedParams}` : `/api/admin/invoicing/backfills/`
}

/**
 * Ops-only switch-on backfills (CORE-8906, CORE-8910).
 *
 * * ``POST /api/admin/invoicing/backfills/``      — enqueue a backfill for one billing entity
 * * ``GET  /api/admin/invoicing/backfills/``      — list backfills, newest first
 * * ``GET  /api/admin/invoicing/backfills/<id>/`` — the backfill record and its reconciliation report
 *
 * A backfill mirrors what was already billed (on Invoiced.com or by direct
 * charge) into locked BACKFILL runs, builds DRAFTs for what was not, and
 * reports the rest. It only reads from Invoiced.com.
 * @summary List switch-on backfills, newest first.
 */
export const adminInvoicingBackfillsList = async (params?: AdminInvoicingBackfillsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedInvoicingBackfillListList> => {

  return customFetch<PaginatedInvoicingBackfillListList>(getAdminInvoicingBackfillsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminInvoicingBackfillsListInfiniteQueryKey = (params?: AdminInvoicingBackfillsListParams,) => {
    return [
    'infinite', `/api/admin/invoicing/backfills/`, ...(params ? [params] : [])
    ] as const;
    }

export const getAdminInvoicingBackfillsListQueryKey = (params?: AdminInvoicingBackfillsListParams,) => {
    return [
    `/api/admin/invoicing/backfills/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminInvoicingBackfillsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof adminInvoicingBackfillsList>>, AdminInvoicingBackfillsListParams['page']>, TError = void>(params?: AdminInvoicingBackfillsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminInvoicingBackfillsList>>, TError, TData, QueryKey, AdminInvoicingBackfillsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminInvoicingBackfillsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminInvoicingBackfillsList>>, QueryKey, AdminInvoicingBackfillsListParams['page']> = ({ signal, pageParam }) => adminInvoicingBackfillsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminInvoicingBackfillsList>>, TError, TData, QueryKey, AdminInvoicingBackfillsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminInvoicingBackfillsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminInvoicingBackfillsList>>>
export type AdminInvoicingBackfillsListInfiniteQueryError = void


export function useAdminInvoicingBackfillsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminInvoicingBackfillsList>>, AdminInvoicingBackfillsListParams['page']>, TError = void>(
 params: undefined |  AdminInvoicingBackfillsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminInvoicingBackfillsList>>, TError, TData, QueryKey, AdminInvoicingBackfillsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminInvoicingBackfillsList>>,
          TError,
          Awaited<ReturnType<typeof adminInvoicingBackfillsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminInvoicingBackfillsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminInvoicingBackfillsList>>, AdminInvoicingBackfillsListParams['page']>, TError = void>(
 params?: AdminInvoicingBackfillsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminInvoicingBackfillsList>>, TError, TData, QueryKey, AdminInvoicingBackfillsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminInvoicingBackfillsList>>,
          TError,
          Awaited<ReturnType<typeof adminInvoicingBackfillsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminInvoicingBackfillsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminInvoicingBackfillsList>>, AdminInvoicingBackfillsListParams['page']>, TError = void>(
 params?: AdminInvoicingBackfillsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminInvoicingBackfillsList>>, TError, TData, QueryKey, AdminInvoicingBackfillsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List switch-on backfills, newest first.
 */

export function useAdminInvoicingBackfillsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminInvoicingBackfillsList>>, AdminInvoicingBackfillsListParams['page']>, TError = void>(
 params?: AdminInvoicingBackfillsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminInvoicingBackfillsList>>, TError, TData, QueryKey, AdminInvoicingBackfillsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminInvoicingBackfillsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminInvoicingBackfillsListQueryOptions = <TData = Awaited<ReturnType<typeof adminInvoicingBackfillsList>>, TError = void>(params?: AdminInvoicingBackfillsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingBackfillsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminInvoicingBackfillsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminInvoicingBackfillsList>>> = ({ signal }) => adminInvoicingBackfillsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingBackfillsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminInvoicingBackfillsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminInvoicingBackfillsList>>>
export type AdminInvoicingBackfillsListQueryError = void


export function useAdminInvoicingBackfillsList<TData = Awaited<ReturnType<typeof adminInvoicingBackfillsList>>, TError = void>(
 params: undefined |  AdminInvoicingBackfillsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingBackfillsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminInvoicingBackfillsList>>,
          TError,
          Awaited<ReturnType<typeof adminInvoicingBackfillsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminInvoicingBackfillsList<TData = Awaited<ReturnType<typeof adminInvoicingBackfillsList>>, TError = void>(
 params?: AdminInvoicingBackfillsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingBackfillsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminInvoicingBackfillsList>>,
          TError,
          Awaited<ReturnType<typeof adminInvoicingBackfillsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminInvoicingBackfillsList<TData = Awaited<ReturnType<typeof adminInvoicingBackfillsList>>, TError = void>(
 params?: AdminInvoicingBackfillsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingBackfillsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List switch-on backfills, newest first.
 */

export function useAdminInvoicingBackfillsList<TData = Awaited<ReturnType<typeof adminInvoicingBackfillsList>>, TError = void>(
 params?: AdminInvoicingBackfillsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingBackfillsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminInvoicingBackfillsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminInvoicingBackfillsCreateUrl = () => {




  return `/api/admin/invoicing/backfills/`
}

/**
 * Record a PENDING backfill and run its pipeline in the background.
 *
 * * 202 — the backfill at PENDING. Poll ``GET /backfills/<id>/`` for
 *   COMPLETED / FAILED and the report.
 * * 400 — the entity does not exist or bills through its organization.
 * * 409 — the entity already has a backfill PENDING or RUNNING; its id
 *   is in ``backfill_id``.
 * @summary Enqueue a switch-on backfill for one billing entity.
 */
export const adminInvoicingBackfillsCreate = async (invoicingBackfillCreateRequest: InvoicingBackfillCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<InvoicingBackfill> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<InvoicingBackfill>(getAdminInvoicingBackfillsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(invoicingBackfillCreateRequest)
  }
);}





export const getAdminInvoicingBackfillsCreateMutationKey = () => ['adminInvoicingBackfillsCreate'] as const;

export const getAdminInvoicingBackfillsCreateMutationOptions = <TError = void | InvoicingBackfillConflictError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInvoicingBackfillsCreate>>, TError,AdminInvoicingBackfillsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminInvoicingBackfillsCreate>>, TError,AdminInvoicingBackfillsCreateMutationVariables, TContext> => {

const mutationKey = getAdminInvoicingBackfillsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminInvoicingBackfillsCreate>>, AdminInvoicingBackfillsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminInvoicingBackfillsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminInvoicingBackfillsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminInvoicingBackfillsCreate>>>
    export type AdminInvoicingBackfillsCreateMutationBody = InvoicingBackfillCreateRequest
    export type AdminInvoicingBackfillsCreateMutationError = void | InvoicingBackfillConflictError
    export type AdminInvoicingBackfillsCreateMutationVariables = {data: InvoicingBackfillCreateRequest}

    /**
 * @summary Enqueue a switch-on backfill for one billing entity.
 */
export const useAdminInvoicingBackfillsCreate = <TError = void | InvoicingBackfillConflictError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInvoicingBackfillsCreate>>, TError,AdminInvoicingBackfillsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminInvoicingBackfillsCreate>>,
        TError,
        AdminInvoicingBackfillsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminInvoicingBackfillsCreateMutationOptions(options), queryClient);
    }
    export const getAdminInvoicingBackfillsRetrieveUrl = (id: number,) => {




  return `/api/admin/invoicing/backfills/${id}/`
}

/**
 * Ops-only switch-on backfills (CORE-8906, CORE-8910).
 *
 * * ``POST /api/admin/invoicing/backfills/``      — enqueue a backfill for one billing entity
 * * ``GET  /api/admin/invoicing/backfills/``      — list backfills, newest first
 * * ``GET  /api/admin/invoicing/backfills/<id>/`` — the backfill record and its reconciliation report
 *
 * A backfill mirrors what was already billed (on Invoiced.com or by direct
 * charge) into locked BACKFILL runs, builds DRAFTs for what was not, and
 * reports the rest. It only reads from Invoiced.com.
 */
export const adminInvoicingBackfillsRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<InvoicingBackfill> => {

  return customFetch<InvoicingBackfill>(getAdminInvoicingBackfillsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminInvoicingBackfillsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/admin/invoicing/backfills/${id}/`
    ] as const;
    }


export const getAdminInvoicingBackfillsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminInvoicingBackfillsRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingBackfillsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminInvoicingBackfillsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminInvoicingBackfillsRetrieve>>> = ({ signal }) => adminInvoicingBackfillsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingBackfillsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminInvoicingBackfillsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminInvoicingBackfillsRetrieve>>>
export type AdminInvoicingBackfillsRetrieveQueryError = void


export function useAdminInvoicingBackfillsRetrieve<TData = Awaited<ReturnType<typeof adminInvoicingBackfillsRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingBackfillsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminInvoicingBackfillsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminInvoicingBackfillsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminInvoicingBackfillsRetrieve<TData = Awaited<ReturnType<typeof adminInvoicingBackfillsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingBackfillsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminInvoicingBackfillsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminInvoicingBackfillsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminInvoicingBackfillsRetrieve<TData = Awaited<ReturnType<typeof adminInvoicingBackfillsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingBackfillsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminInvoicingBackfillsRetrieve<TData = Awaited<ReturnType<typeof adminInvoicingBackfillsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingBackfillsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminInvoicingBackfillsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminInvoicingRunsListUrl = (params?: AdminInvoicingRunsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/invoicing/runs/?${stringifiedParams}` : `/api/admin/invoicing/runs/`
}

/**
 * Ops-only REST surface for browsing and mutating invoicing runs.
 *
 * The list endpoint accepts a ``status`` query param (``DRAFT``, ``CREATED``,
 * ``SENT``, ``DISCARDED``; defaults to ``DRAFT``) so the admin UI can render
 * tabs against one collection. Retrieve is unscoped by status — a
 * CREATED/SENT/DISCARDED run row can render its detail. Mutation actions
 * (``invoiced-create``/``discard``/line-item CRUD) keep DRAFT-only queryset
 * scoping so non-DRAFT parents 404 before the service layer refuses. That
 * scoping is why discarding a CREATED or SENT run 404s here rather than
 * surfacing ``discard_draft``'s 400 — the service-layer refusal is the
 * authority for callers that reach it directly.
 *
 * ``send`` and ``invoiced-delete`` opt out of the DRAFT scoping: they act
 * on CREATED (and, for delete, SENT) runs, and ops pressing the button on
 * any other run needs to be told which status blocked it, so their
 * per-status refusal surfaces as a 400 rather than a 404.
 *
 * A BACKFILL run (CORE-8904) is the exception to both: every mutating or
 * Invoiced.com-calling action answers it with a 409 before any scoping or
 * service call — see ``_BACKFILL_REFUSED_ACTIONS``.
 */
export const adminInvoicingRunsList = async (params?: AdminInvoicingRunsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedInvoicingRunListList> => {

  return customFetch<PaginatedInvoicingRunListList>(getAdminInvoicingRunsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminInvoicingRunsListInfiniteQueryKey = (params?: AdminInvoicingRunsListParams,) => {
    return [
    'infinite', `/api/admin/invoicing/runs/`, ...(params ? [params] : [])
    ] as const;
    }

export const getAdminInvoicingRunsListQueryKey = (params?: AdminInvoicingRunsListParams,) => {
    return [
    `/api/admin/invoicing/runs/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminInvoicingRunsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof adminInvoicingRunsList>>, AdminInvoicingRunsListParams['page']>, TError = void>(params?: AdminInvoicingRunsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminInvoicingRunsList>>, TError, TData, QueryKey, AdminInvoicingRunsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminInvoicingRunsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminInvoicingRunsList>>, QueryKey, AdminInvoicingRunsListParams['page']> = ({ signal, pageParam }) => adminInvoicingRunsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminInvoicingRunsList>>, TError, TData, QueryKey, AdminInvoicingRunsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminInvoicingRunsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminInvoicingRunsList>>>
export type AdminInvoicingRunsListInfiniteQueryError = void


export function useAdminInvoicingRunsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminInvoicingRunsList>>, AdminInvoicingRunsListParams['page']>, TError = void>(
 params: undefined |  AdminInvoicingRunsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminInvoicingRunsList>>, TError, TData, QueryKey, AdminInvoicingRunsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminInvoicingRunsList>>,
          TError,
          Awaited<ReturnType<typeof adminInvoicingRunsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminInvoicingRunsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminInvoicingRunsList>>, AdminInvoicingRunsListParams['page']>, TError = void>(
 params?: AdminInvoicingRunsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminInvoicingRunsList>>, TError, TData, QueryKey, AdminInvoicingRunsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminInvoicingRunsList>>,
          TError,
          Awaited<ReturnType<typeof adminInvoicingRunsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminInvoicingRunsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminInvoicingRunsList>>, AdminInvoicingRunsListParams['page']>, TError = void>(
 params?: AdminInvoicingRunsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminInvoicingRunsList>>, TError, TData, QueryKey, AdminInvoicingRunsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminInvoicingRunsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminInvoicingRunsList>>, AdminInvoicingRunsListParams['page']>, TError = void>(
 params?: AdminInvoicingRunsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminInvoicingRunsList>>, TError, TData, QueryKey, AdminInvoicingRunsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminInvoicingRunsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminInvoicingRunsListQueryOptions = <TData = Awaited<ReturnType<typeof adminInvoicingRunsList>>, TError = void>(params?: AdminInvoicingRunsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingRunsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminInvoicingRunsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminInvoicingRunsList>>> = ({ signal }) => adminInvoicingRunsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingRunsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminInvoicingRunsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminInvoicingRunsList>>>
export type AdminInvoicingRunsListQueryError = void


export function useAdminInvoicingRunsList<TData = Awaited<ReturnType<typeof adminInvoicingRunsList>>, TError = void>(
 params: undefined |  AdminInvoicingRunsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingRunsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminInvoicingRunsList>>,
          TError,
          Awaited<ReturnType<typeof adminInvoicingRunsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminInvoicingRunsList<TData = Awaited<ReturnType<typeof adminInvoicingRunsList>>, TError = void>(
 params?: AdminInvoicingRunsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingRunsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminInvoicingRunsList>>,
          TError,
          Awaited<ReturnType<typeof adminInvoicingRunsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminInvoicingRunsList<TData = Awaited<ReturnType<typeof adminInvoicingRunsList>>, TError = void>(
 params?: AdminInvoicingRunsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingRunsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminInvoicingRunsList<TData = Awaited<ReturnType<typeof adminInvoicingRunsList>>, TError = void>(
 params?: AdminInvoicingRunsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingRunsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminInvoicingRunsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminInvoicingRunsRetrieveUrl = (id: number,) => {




  return `/api/admin/invoicing/runs/${id}/`
}

/**
 * Ops-only REST surface for browsing and mutating invoicing runs.
 *
 * The list endpoint accepts a ``status`` query param (``DRAFT``, ``CREATED``,
 * ``SENT``, ``DISCARDED``; defaults to ``DRAFT``) so the admin UI can render
 * tabs against one collection. Retrieve is unscoped by status — a
 * CREATED/SENT/DISCARDED run row can render its detail. Mutation actions
 * (``invoiced-create``/``discard``/line-item CRUD) keep DRAFT-only queryset
 * scoping so non-DRAFT parents 404 before the service layer refuses. That
 * scoping is why discarding a CREATED or SENT run 404s here rather than
 * surfacing ``discard_draft``'s 400 — the service-layer refusal is the
 * authority for callers that reach it directly.
 *
 * ``send`` and ``invoiced-delete`` opt out of the DRAFT scoping: they act
 * on CREATED (and, for delete, SENT) runs, and ops pressing the button on
 * any other run needs to be told which status blocked it, so their
 * per-status refusal surfaces as a 400 rather than a 404.
 *
 * A BACKFILL run (CORE-8904) is the exception to both: every mutating or
 * Invoiced.com-calling action answers it with a 409 before any scoping or
 * service call — see ``_BACKFILL_REFUSED_ACTIONS``.
 */
export const adminInvoicingRunsRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<InvoicingRunDetail> => {

  return customFetch<InvoicingRunDetail>(getAdminInvoicingRunsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminInvoicingRunsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/admin/invoicing/runs/${id}/`
    ] as const;
    }


export const getAdminInvoicingRunsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminInvoicingRunsRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingRunsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminInvoicingRunsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminInvoicingRunsRetrieve>>> = ({ signal }) => adminInvoicingRunsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingRunsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminInvoicingRunsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminInvoicingRunsRetrieve>>>
export type AdminInvoicingRunsRetrieveQueryError = void


export function useAdminInvoicingRunsRetrieve<TData = Awaited<ReturnType<typeof adminInvoicingRunsRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingRunsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminInvoicingRunsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminInvoicingRunsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminInvoicingRunsRetrieve<TData = Awaited<ReturnType<typeof adminInvoicingRunsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingRunsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminInvoicingRunsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminInvoicingRunsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminInvoicingRunsRetrieve<TData = Awaited<ReturnType<typeof adminInvoicingRunsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingRunsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminInvoicingRunsRetrieve<TData = Awaited<ReturnType<typeof adminInvoicingRunsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingRunsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminInvoicingRunsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminInvoicingRunsDiscardCreateUrl = (id: number,) => {




  return `/api/admin/invoicing/runs/${id}/discard/`
}

/**
 * Mark the draft as DISCARDED.
 */
export const adminInvoicingRunsDiscardCreate = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<InvoicingRunDetail> => {

  return customFetch<InvoicingRunDetail>(getAdminInvoicingRunsDiscardCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminInvoicingRunsDiscardCreateMutationKey = () => ['adminInvoicingRunsDiscardCreate'] as const;

export const getAdminInvoicingRunsDiscardCreateMutationOptions = <TError = void | InvoicingRunBackfillLocked,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInvoicingRunsDiscardCreate>>, TError,AdminInvoicingRunsDiscardCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminInvoicingRunsDiscardCreate>>, TError,AdminInvoicingRunsDiscardCreateMutationVariables, TContext> => {

const mutationKey = getAdminInvoicingRunsDiscardCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminInvoicingRunsDiscardCreate>>, AdminInvoicingRunsDiscardCreateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  adminInvoicingRunsDiscardCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminInvoicingRunsDiscardCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminInvoicingRunsDiscardCreate>>>

    export type AdminInvoicingRunsDiscardCreateMutationError = void | InvoicingRunBackfillLocked
    export type AdminInvoicingRunsDiscardCreateMutationVariables = {id: number}

    export const useAdminInvoicingRunsDiscardCreate = <TError = void | InvoicingRunBackfillLocked,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInvoicingRunsDiscardCreate>>, TError,AdminInvoicingRunsDiscardCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminInvoicingRunsDiscardCreate>>,
        TError,
        AdminInvoicingRunsDiscardCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminInvoicingRunsDiscardCreateMutationOptions(options), queryClient);
    }
    export const getAdminInvoicingRunsInvoicedCreateUrl = (id: number,) => {




  return `/api/admin/invoicing/runs/${id}/invoiced-create/`
}

/**
 * Create the Invoiced.com invoice for the draft.
 *
 * Delegates to
 * ``api.invoicing.services.create.create_invoice_from_draft`` (WORK-5893).
 * Validation refusals surface as 400. Upstream / network failures
 * during the Invoiced.com round-trip propagate to Django's default
 * 500 handler — the run stays in CREATING for the reconciliation
 * sweep to recover on the next cycle.
 * @summary Create the Invoiced.com invoice for a DRAFT run.
 */
export const adminInvoicingRunsInvoicedCreate = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<InvoicingRunDetail> => {

  return customFetch<InvoicingRunDetail>(getAdminInvoicingRunsInvoicedCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminInvoicingRunsInvoicedCreateMutationKey = () => ['adminInvoicingRunsInvoicedCreate'] as const;

export const getAdminInvoicingRunsInvoicedCreateMutationOptions = <TError = void | InvoicingRunBackfillLocked,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInvoicingRunsInvoicedCreate>>, TError,AdminInvoicingRunsInvoicedCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminInvoicingRunsInvoicedCreate>>, TError,AdminInvoicingRunsInvoicedCreateMutationVariables, TContext> => {

const mutationKey = getAdminInvoicingRunsInvoicedCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminInvoicingRunsInvoicedCreate>>, AdminInvoicingRunsInvoicedCreateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  adminInvoicingRunsInvoicedCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminInvoicingRunsInvoicedCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminInvoicingRunsInvoicedCreate>>>

    export type AdminInvoicingRunsInvoicedCreateMutationError = void | InvoicingRunBackfillLocked
    export type AdminInvoicingRunsInvoicedCreateMutationVariables = {id: number}

    /**
 * @summary Create the Invoiced.com invoice for a DRAFT run.
 */
export const useAdminInvoicingRunsInvoicedCreate = <TError = void | InvoicingRunBackfillLocked,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInvoicingRunsInvoicedCreate>>, TError,AdminInvoicingRunsInvoicedCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminInvoicingRunsInvoicedCreate>>,
        TError,
        AdminInvoicingRunsInvoicedCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminInvoicingRunsInvoicedCreateMutationOptions(options), queryClient);
    }
    export const getAdminInvoicingRunsInvoicedDeleteUrl = (id: number,) => {




  return `/api/admin/invoicing/runs/${id}/invoiced-delete/`
}

/**
 * Delete the run's Invoiced.com invoice and mark the run DELETED.
 *
 * Delegates to ``InvoicingRunService.delete_invoiced_invoice``
 * (WORK-8416). A deleted run's line items leave the double-billing
 * guard, so a new draft for the same period picks their source rows up
 * again.
 *
 * * 200 — the run at DELETED, as ``InvoicingRunDetailSerializer``.
 * * 400 — the run is not CREATED / SENT, has no invoice id, or its
 *   invoice has a payment recorded on Invoiced.com (partial included).
 * * 502 — an Invoiced.com API call failed; nothing was written locally
 *   and the invoice may still exist, so retrying is safe.
 * * 202 — the invoice was deleted on Invoiced.com but recording DELETED
 *   locally failed. Not a 200: that payload would describe a run still
 *   reading CREATED / SENT. Retrying the delete reconciles it.
 * @summary Delete a CREATED or SENT run's Invoiced.com invoice.
 */
export const adminInvoicingRunsInvoicedDelete = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<InvoicingRunDetail | InvoicingRunDeleteNeedsReconciliation> => {

  return customFetch<InvoicingRunDetail | InvoicingRunDeleteNeedsReconciliation>(getAdminInvoicingRunsInvoicedDeleteUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminInvoicingRunsInvoicedDeleteMutationKey = () => ['adminInvoicingRunsInvoicedDelete'] as const;

export const getAdminInvoicingRunsInvoicedDeleteMutationOptions = <TError = void | InvoicingRunBackfillLocked | InvoicingRunDeleteUpstreamError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInvoicingRunsInvoicedDelete>>, TError,AdminInvoicingRunsInvoicedDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminInvoicingRunsInvoicedDelete>>, TError,AdminInvoicingRunsInvoicedDeleteMutationVariables, TContext> => {

const mutationKey = getAdminInvoicingRunsInvoicedDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminInvoicingRunsInvoicedDelete>>, AdminInvoicingRunsInvoicedDeleteMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  adminInvoicingRunsInvoicedDelete(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminInvoicingRunsInvoicedDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof adminInvoicingRunsInvoicedDelete>>>

    export type AdminInvoicingRunsInvoicedDeleteMutationError = void | InvoicingRunBackfillLocked | InvoicingRunDeleteUpstreamError
    export type AdminInvoicingRunsInvoicedDeleteMutationVariables = {id: number}

    /**
 * @summary Delete a CREATED or SENT run's Invoiced.com invoice.
 */
export const useAdminInvoicingRunsInvoicedDelete = <TError = void | InvoicingRunBackfillLocked | InvoicingRunDeleteUpstreamError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInvoicingRunsInvoicedDelete>>, TError,AdminInvoicingRunsInvoicedDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminInvoicingRunsInvoicedDelete>>,
        TError,
        AdminInvoicingRunsInvoicedDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getAdminInvoicingRunsInvoicedDeleteMutationOptions(options), queryClient);
    }
    export const getAdminInvoicingRunsInvoicedPaymentStateUrl = (id: number,) => {




  return `/api/admin/invoicing/runs/${id}/invoiced-payment-state/`
}

/**
 * Whether the run's Invoiced.com invoice has any payment on it (WORK-8415).
 *
 * Nothing about payment is stored locally and Invoiced.com sends no
 * invoice webhook, so this is a live ``GET /invoices/{id}`` on every call;
 * the web detail page uses ``has_payment`` to decide whether to offer
 * Delete. A run with no invoice to look up is a 409, not a 404 — the run
 * exists, it is just in the wrong state. So is an Invoiced.com 404: the
 * invoice was deleted there but the local DELETED write did not land (the
 * delete's 202 reconcile case), and a retried delete reconciles it. Any
 * other SDK failure is a 502: the upstream is what failed, and a 500 would
 * read as our bug.
 * @summary Read a run's Invoiced.com invoice payment state live.
 */
export const adminInvoicingRunsInvoicedPaymentState = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<InvoicingRunPaymentState> => {

  return customFetch<InvoicingRunPaymentState>(getAdminInvoicingRunsInvoicedPaymentStateUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminInvoicingRunsInvoicedPaymentStateQueryKey = (id: number,) => {
    return [
    `/api/admin/invoicing/runs/${id}/invoiced-payment-state/`
    ] as const;
    }


export const getAdminInvoicingRunsInvoicedPaymentStateQueryOptions = <TData = Awaited<ReturnType<typeof adminInvoicingRunsInvoicedPaymentState>>, TError = void | InvoicingRunPaymentStateUnavailable>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingRunsInvoicedPaymentState>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminInvoicingRunsInvoicedPaymentStateQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminInvoicingRunsInvoicedPaymentState>>> = ({ signal }) => adminInvoicingRunsInvoicedPaymentState(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingRunsInvoicedPaymentState>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminInvoicingRunsInvoicedPaymentStateQueryResult = NonNullable<Awaited<ReturnType<typeof adminInvoicingRunsInvoicedPaymentState>>>
export type AdminInvoicingRunsInvoicedPaymentStateQueryError = void | InvoicingRunPaymentStateUnavailable


export function useAdminInvoicingRunsInvoicedPaymentState<TData = Awaited<ReturnType<typeof adminInvoicingRunsInvoicedPaymentState>>, TError = void | InvoicingRunPaymentStateUnavailable>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingRunsInvoicedPaymentState>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminInvoicingRunsInvoicedPaymentState>>,
          TError,
          Awaited<ReturnType<typeof adminInvoicingRunsInvoicedPaymentState>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminInvoicingRunsInvoicedPaymentState<TData = Awaited<ReturnType<typeof adminInvoicingRunsInvoicedPaymentState>>, TError = void | InvoicingRunPaymentStateUnavailable>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingRunsInvoicedPaymentState>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminInvoicingRunsInvoicedPaymentState>>,
          TError,
          Awaited<ReturnType<typeof adminInvoicingRunsInvoicedPaymentState>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminInvoicingRunsInvoicedPaymentState<TData = Awaited<ReturnType<typeof adminInvoicingRunsInvoicedPaymentState>>, TError = void | InvoicingRunPaymentStateUnavailable>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingRunsInvoicedPaymentState>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read a run's Invoiced.com invoice payment state live.
 */

export function useAdminInvoicingRunsInvoicedPaymentState<TData = Awaited<ReturnType<typeof adminInvoicingRunsInvoicedPaymentState>>, TError = void | InvoicingRunPaymentStateUnavailable>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicingRunsInvoicedPaymentState>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminInvoicingRunsInvoicedPaymentStateQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminInvoicingRunsLineItemsCreateUrl = (id: number,) => {




  return `/api/admin/invoicing/runs/${id}/line-items/`
}

/**
 * Add a MANUAL line item to a draft.
 */
export const adminInvoicingRunsLineItemsCreate = async (id: number,
    invoicingLineItemManualCreateRequest: InvoicingLineItemManualCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<InvoicingLineItem> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<InvoicingLineItem>(getAdminInvoicingRunsLineItemsCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(invoicingLineItemManualCreateRequest)
  }
);}





export const getAdminInvoicingRunsLineItemsCreateMutationKey = () => ['adminInvoicingRunsLineItemsCreate'] as const;

export const getAdminInvoicingRunsLineItemsCreateMutationOptions = <TError = void | InvoicingRunBackfillLocked,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInvoicingRunsLineItemsCreate>>, TError,AdminInvoicingRunsLineItemsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminInvoicingRunsLineItemsCreate>>, TError,AdminInvoicingRunsLineItemsCreateMutationVariables, TContext> => {

const mutationKey = getAdminInvoicingRunsLineItemsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminInvoicingRunsLineItemsCreate>>, AdminInvoicingRunsLineItemsCreateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  adminInvoicingRunsLineItemsCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminInvoicingRunsLineItemsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminInvoicingRunsLineItemsCreate>>>
    export type AdminInvoicingRunsLineItemsCreateMutationBody = InvoicingLineItemManualCreateRequest
    export type AdminInvoicingRunsLineItemsCreateMutationError = void | InvoicingRunBackfillLocked
    export type AdminInvoicingRunsLineItemsCreateMutationVariables = {id: number;data: InvoicingLineItemManualCreateRequest}

    export const useAdminInvoicingRunsLineItemsCreate = <TError = void | InvoicingRunBackfillLocked,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInvoicingRunsLineItemsCreate>>, TError,AdminInvoicingRunsLineItemsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminInvoicingRunsLineItemsCreate>>,
        TError,
        AdminInvoicingRunsLineItemsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminInvoicingRunsLineItemsCreateMutationOptions(options), queryClient);
    }
    export const getAdminInvoicingRunsLineItemsPartialUpdateUrl = (id: number,
    lineItemId: number,) => {




  return `/api/admin/invoicing/runs/${id}/line-items/${lineItemId}/`
}

/**
 * PATCH edits mutable fields; DELETE soft-deletes the line.
 */
export const adminInvoicingRunsLineItemsPartialUpdate = async (id: number,
    lineItemId: number,
    patchedInvoicingLineItemEditRequest?: PatchedInvoicingLineItemEditRequest, options?: Parameters<typeof customFetch>[1]): Promise<InvoicingLineItem> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<InvoicingLineItem>(getAdminInvoicingRunsLineItemsPartialUpdateUrl(id,lineItemId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedInvoicingLineItemEditRequest)
  }
);}





export const getAdminInvoicingRunsLineItemsPartialUpdateMutationKey = () => ['adminInvoicingRunsLineItemsPartialUpdate'] as const;

export const getAdminInvoicingRunsLineItemsPartialUpdateMutationOptions = <TError = void | InvoicingRunBackfillLocked,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInvoicingRunsLineItemsPartialUpdate>>, TError,AdminInvoicingRunsLineItemsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminInvoicingRunsLineItemsPartialUpdate>>, TError,AdminInvoicingRunsLineItemsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminInvoicingRunsLineItemsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminInvoicingRunsLineItemsPartialUpdate>>, AdminInvoicingRunsLineItemsPartialUpdateMutationVariables> = (props) => {
          const {id,lineItemId,data} = props ?? {};

          return  adminInvoicingRunsLineItemsPartialUpdate(id,lineItemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminInvoicingRunsLineItemsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminInvoicingRunsLineItemsPartialUpdate>>>
    export type AdminInvoicingRunsLineItemsPartialUpdateMutationBody = PatchedInvoicingLineItemEditRequest | undefined
    export type AdminInvoicingRunsLineItemsPartialUpdateMutationError = void | InvoicingRunBackfillLocked
    export type AdminInvoicingRunsLineItemsPartialUpdateMutationVariables = {id: number;lineItemId: number;data?: PatchedInvoicingLineItemEditRequest}

    export const useAdminInvoicingRunsLineItemsPartialUpdate = <TError = void | InvoicingRunBackfillLocked,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInvoicingRunsLineItemsPartialUpdate>>, TError,AdminInvoicingRunsLineItemsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminInvoicingRunsLineItemsPartialUpdate>>,
        TError,
        AdminInvoicingRunsLineItemsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminInvoicingRunsLineItemsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getAdminInvoicingRunsLineItemsDestroyUrl = (id: number,
    lineItemId: number,) => {




  return `/api/admin/invoicing/runs/${id}/line-items/${lineItemId}/`
}

/**
 * PATCH edits mutable fields; DELETE soft-deletes the line.
 */
export const adminInvoicingRunsLineItemsDestroy = async (id: number,
    lineItemId: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getAdminInvoicingRunsLineItemsDestroyUrl(id,lineItemId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminInvoicingRunsLineItemsDestroyMutationKey = () => ['adminInvoicingRunsLineItemsDestroy'] as const;

export const getAdminInvoicingRunsLineItemsDestroyMutationOptions = <TError = void | InvoicingRunBackfillLocked,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInvoicingRunsLineItemsDestroy>>, TError,AdminInvoicingRunsLineItemsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminInvoicingRunsLineItemsDestroy>>, TError,AdminInvoicingRunsLineItemsDestroyMutationVariables, TContext> => {

const mutationKey = getAdminInvoicingRunsLineItemsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminInvoicingRunsLineItemsDestroy>>, AdminInvoicingRunsLineItemsDestroyMutationVariables> = (props) => {
          const {id,lineItemId} = props ?? {};

          return  adminInvoicingRunsLineItemsDestroy(id,lineItemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminInvoicingRunsLineItemsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminInvoicingRunsLineItemsDestroy>>>

    export type AdminInvoicingRunsLineItemsDestroyMutationError = void | InvoicingRunBackfillLocked
    export type AdminInvoicingRunsLineItemsDestroyMutationVariables = {id: number;lineItemId: number}

    export const useAdminInvoicingRunsLineItemsDestroy = <TError = void | InvoicingRunBackfillLocked,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInvoicingRunsLineItemsDestroy>>, TError,AdminInvoicingRunsLineItemsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminInvoicingRunsLineItemsDestroy>>,
        TError,
        AdminInvoicingRunsLineItemsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminInvoicingRunsLineItemsDestroyMutationOptions(options), queryClient);
    }
    export const getAdminInvoicingRunsSendUrl = (id: number,) => {




  return `/api/admin/invoicing/runs/${id}/send/`
}

/**
 * Email the created invoice to the customer, then mark the run SENT.
 *
 * Delegates to ``api.invoicing.services.send.send_invoice_for_run``
 * (WORK-8253) — the same service the nightly batch's SEND automation
 * level calls, so a manual send and an automated one are the same
 * operation. On success the run is at ``SENT`` with ``sent_at`` /
 * ``sent_by`` stamped, and the full detail payload comes back so the
 * caller can drop it straight into its cache.
 *
 * **Double-send is safe.** The send POST carries the stable per-run
 * idempotency key ``invoicing-run-email-<run_id>``, which Invoiced.com
 * dedupes — a manual send chasing an automated one, or an ops user
 * double-clicking, returns the original email records without emailing
 * the customer again.
 *
 * Refusals surface as 400 with a per-status message: a DRAFT run has no
 * invoice to send yet, a SENT one has already been sent, a DISCARDED one
 * never will be, a CREATED one with no ``invoiced_invoice_id`` is a data
 * inconsistency, and a send that reached zero recipients means the
 * customer has no default contacts configured on Invoiced.com.
 *
 * Upstream / network failures during the Invoiced.com round-trip
 * propagate to Django's default 500 handler. The run stays at
 * ``CREATED`` with ``sent_at`` null — still visible to the orphaned-send
 * query ``status=CREATED AND sent_at IS NULL`` — and the call is safe to
 * retry, since the idempotency key means a retry cannot double-email.
 *
 * **A post-dispatch failure is a 202, not a 500.** Once the send POST
 * has reached Invoiced.com, anything that fails afterwards leaves the
 * same wreckage: the invoice is out (or may be), and the local record
 * still reads ``CREATED`` with ``sent_at`` null. Letting those fall
 * through to the default handler gave ops a bare 500, which reads as
 * "nothing happened" and invites a resend — the wrong response, since
 * what the run needs is reconciliation. So every
 * :class:`~api.invoicing.services.send.PostDispatchError` is caught
 * here and answered with a body that says the invoice may already be in
 * the customer's inbox, that the local record did not move, and which
 * run to reconcile. Two shapes reach it today — a failed
 * ``CREATED → SENT`` stamp after a confirmed send, and an
 * Invoiced.com response whose email records carried no usable id — and
 * the service supplies the wording for each, since it is the layer that
 * knows which one fired.
 *
 * **Why this cannot swallow a pre-dispatch failure.** A failure before
 * the POST means nothing was emailed, and there a retry is exactly the
 * right instinct — answering it with "may already have been sent" would
 * send an operator to reconcile a run that was never sent and talk them
 * out of the fix. The catch is safe against that because it is a closed
 * hierarchy, never a broad type: ``PostDispatchError`` membership is
 * asserted only by code that knows the POST went out. Notably the
 * client's post-send guard raises a named ``ValueError`` *subclass*
 * while its two pre-flight guards stay plain ``ValueError``, and the
 * service converts only that subclass. So everything pre-dispatch —
 * both client pre-flight guards, SDK connection errors, 4xx / 5xx,
 * auth — is outside this hierarchy, is caught nowhere, and still
 * reaches the 500 handler. ``SendReachedNoRecipientsError`` is the one
 * post-POST failure deliberately left out: Invoiced.com emailed nobody
 * because the customer has no default contacts, so it is a 400 and
 * retry-after-fixing genuinely is the right move.
 *
 * 202 is chosen over the alternatives deliberately:
 *
 * * Not a 5xx or a 4xx — neither the server nor the caller failed at
 *   the thing this endpoint exists to do. The invoice was emailed.
 * * Not 200 — a 200 carries ``InvoicingRunDetailSerializer``, and that
 *   payload would read ``status=CREATED, sent_at=null``, i.e. a success
 *   response describing a run that looks unsent. The FE drops the detail
 *   payload straight into its cache; handing it that is worse than
 *   handing it a distinct code.
 * * 202 says the request was accepted and acted on while the stored
 *   representation has not caught up — which is precisely the state.
 *   For the stamp-failure shape it also keeps this endpoint agreeing
 *   with :func:`~api.invoicing.services.batch._send_and_stamp`, which
 *   counts exactly that outcome as ``send_succeeded`` rather than a
 *   failure; endpoint and batch disagreeing about what "emailed but
 *   unstamped" means is half of what made the 500 misleading. The
 *   unusable-records shape stays a ``send_email_failed`` tick in the
 *   batch, which is right for a Slack summary — it is an unresolved
 *   send someone has to go look at — and does not conflict with a 202
 *   here, where the operator is being told what to do next rather than
 *   being counted.
 * @summary Email a CREATED run's Invoiced.com invoice to the customer.
 */
export const adminInvoicingRunsSend = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<InvoicingRunDetail | InvoicingRunSendNeedsReconciliation> => {

  return customFetch<InvoicingRunDetail | InvoicingRunSendNeedsReconciliation>(getAdminInvoicingRunsSendUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminInvoicingRunsSendMutationKey = () => ['adminInvoicingRunsSend'] as const;

export const getAdminInvoicingRunsSendMutationOptions = <TError = void | InvoicingRunBackfillLocked,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInvoicingRunsSend>>, TError,AdminInvoicingRunsSendMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminInvoicingRunsSend>>, TError,AdminInvoicingRunsSendMutationVariables, TContext> => {

const mutationKey = getAdminInvoicingRunsSendMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminInvoicingRunsSend>>, AdminInvoicingRunsSendMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  adminInvoicingRunsSend(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminInvoicingRunsSendMutationResult = NonNullable<Awaited<ReturnType<typeof adminInvoicingRunsSend>>>

    export type AdminInvoicingRunsSendMutationError = void | InvoicingRunBackfillLocked
    export type AdminInvoicingRunsSendMutationVariables = {id: number}

    /**
 * @summary Email a CREATED run's Invoiced.com invoice to the customer.
 */
export const useAdminInvoicingRunsSend = <TError = void | InvoicingRunBackfillLocked,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInvoicingRunsSend>>, TError,AdminInvoicingRunsSendMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminInvoicingRunsSend>>,
        TError,
        AdminInvoicingRunsSendMutationVariables,
        TContext
      > => {
      return useMutation(getAdminInvoicingRunsSendMutationOptions(options), queryClient);
    }
    export const getAdminInvoicingRunsUndeleteLineItemsCreateUrl = (id: number,
    lineItemId: number,) => {




  return `/api/admin/invoicing/runs/${id}/undelete-line-items/${lineItemId}/`
}

/**
 * Reverse a soft-delete on a draft line item.
 */
export const adminInvoicingRunsUndeleteLineItemsCreate = async (id: number,
    lineItemId: number, options?: Parameters<typeof customFetch>[1]): Promise<InvoicingLineItem> => {

  return customFetch<InvoicingLineItem>(getAdminInvoicingRunsUndeleteLineItemsCreateUrl(id,lineItemId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminInvoicingRunsUndeleteLineItemsCreateMutationKey = () => ['adminInvoicingRunsUndeleteLineItemsCreate'] as const;

export const getAdminInvoicingRunsUndeleteLineItemsCreateMutationOptions = <TError = void | InvoicingRunBackfillLocked,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInvoicingRunsUndeleteLineItemsCreate>>, TError,AdminInvoicingRunsUndeleteLineItemsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminInvoicingRunsUndeleteLineItemsCreate>>, TError,AdminInvoicingRunsUndeleteLineItemsCreateMutationVariables, TContext> => {

const mutationKey = getAdminInvoicingRunsUndeleteLineItemsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminInvoicingRunsUndeleteLineItemsCreate>>, AdminInvoicingRunsUndeleteLineItemsCreateMutationVariables> = (props) => {
          const {id,lineItemId} = props ?? {};

          return  adminInvoicingRunsUndeleteLineItemsCreate(id,lineItemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminInvoicingRunsUndeleteLineItemsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminInvoicingRunsUndeleteLineItemsCreate>>>

    export type AdminInvoicingRunsUndeleteLineItemsCreateMutationError = void | InvoicingRunBackfillLocked
    export type AdminInvoicingRunsUndeleteLineItemsCreateMutationVariables = {id: number;lineItemId: number}

    export const useAdminInvoicingRunsUndeleteLineItemsCreate = <TError = void | InvoicingRunBackfillLocked,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInvoicingRunsUndeleteLineItemsCreate>>, TError,AdminInvoicingRunsUndeleteLineItemsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminInvoicingRunsUndeleteLineItemsCreate>>,
        TError,
        AdminInvoicingRunsUndeleteLineItemsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminInvoicingRunsUndeleteLineItemsCreateMutationOptions(options), queryClient);
    }
    export const getAdminJobPostingsListUrl = (params?: AdminJobPostingsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/job-postings/?${stringifiedParams}` : `/api/admin/job-postings/`
}

/**
 * Admin-only access to job postings across all locations.
 *
 * Read: mirrors JobPostingView's list/retrieve behavior but ignores the
 * LOCATION_ID_HTTP_HEADER, so admins always see every location's postings
 * in a single call. Defaults to non-archived; pass ?status=... to override.
 *
 * Write: PATCH /{id}/ performs the PENDING → OPEN approval transition only.
 * Full-replacement PUT is not supported.
 */
export const adminJobPostingsList = async (params?: AdminJobPostingsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedAdminJobPostingList> => {

  return customFetch<PaginatedAdminJobPostingList>(getAdminJobPostingsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminJobPostingsListInfiniteQueryKey = (params?: AdminJobPostingsListParams,) => {
    return [
    'infinite', `/api/admin/job-postings/`, ...(params ? [params] : [])
    ] as const;
    }

export const getAdminJobPostingsListQueryKey = (params?: AdminJobPostingsListParams,) => {
    return [
    `/api/admin/job-postings/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminJobPostingsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof adminJobPostingsList>>, AdminJobPostingsListParams['page']>, TError = void>(params?: AdminJobPostingsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminJobPostingsList>>, TError, TData, QueryKey, AdminJobPostingsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminJobPostingsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminJobPostingsList>>, QueryKey, AdminJobPostingsListParams['page']> = ({ signal, pageParam }) => adminJobPostingsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminJobPostingsList>>, TError, TData, QueryKey, AdminJobPostingsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminJobPostingsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminJobPostingsList>>>
export type AdminJobPostingsListInfiniteQueryError = void


export function useAdminJobPostingsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminJobPostingsList>>, AdminJobPostingsListParams['page']>, TError = void>(
 params: undefined |  AdminJobPostingsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminJobPostingsList>>, TError, TData, QueryKey, AdminJobPostingsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminJobPostingsList>>,
          TError,
          Awaited<ReturnType<typeof adminJobPostingsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminJobPostingsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminJobPostingsList>>, AdminJobPostingsListParams['page']>, TError = void>(
 params?: AdminJobPostingsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminJobPostingsList>>, TError, TData, QueryKey, AdminJobPostingsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminJobPostingsList>>,
          TError,
          Awaited<ReturnType<typeof adminJobPostingsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminJobPostingsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminJobPostingsList>>, AdminJobPostingsListParams['page']>, TError = void>(
 params?: AdminJobPostingsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminJobPostingsList>>, TError, TData, QueryKey, AdminJobPostingsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminJobPostingsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminJobPostingsList>>, AdminJobPostingsListParams['page']>, TError = void>(
 params?: AdminJobPostingsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminJobPostingsList>>, TError, TData, QueryKey, AdminJobPostingsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminJobPostingsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminJobPostingsListQueryOptions = <TData = Awaited<ReturnType<typeof adminJobPostingsList>>, TError = void>(params?: AdminJobPostingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobPostingsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminJobPostingsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminJobPostingsList>>> = ({ signal }) => adminJobPostingsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminJobPostingsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminJobPostingsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminJobPostingsList>>>
export type AdminJobPostingsListQueryError = void


export function useAdminJobPostingsList<TData = Awaited<ReturnType<typeof adminJobPostingsList>>, TError = void>(
 params: undefined |  AdminJobPostingsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobPostingsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminJobPostingsList>>,
          TError,
          Awaited<ReturnType<typeof adminJobPostingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminJobPostingsList<TData = Awaited<ReturnType<typeof adminJobPostingsList>>, TError = void>(
 params?: AdminJobPostingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobPostingsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminJobPostingsList>>,
          TError,
          Awaited<ReturnType<typeof adminJobPostingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminJobPostingsList<TData = Awaited<ReturnType<typeof adminJobPostingsList>>, TError = void>(
 params?: AdminJobPostingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobPostingsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminJobPostingsList<TData = Awaited<ReturnType<typeof adminJobPostingsList>>, TError = void>(
 params?: AdminJobPostingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobPostingsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminJobPostingsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminJobPostingsRetrieveUrl = (id: string,) => {




  return `/api/admin/job-postings/${id}/`
}

/**
 * Admin-only access to job postings across all locations.
 *
 * Read: mirrors JobPostingView's list/retrieve behavior but ignores the
 * LOCATION_ID_HTTP_HEADER, so admins always see every location's postings
 * in a single call. Defaults to non-archived; pass ?status=... to override.
 *
 * Write: PATCH /{id}/ performs the PENDING → OPEN approval transition only.
 * Full-replacement PUT is not supported.
 */
export const adminJobPostingsRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<AdminJobPostingSerializerWithApplicationDate> => {

  return customFetch<AdminJobPostingSerializerWithApplicationDate>(getAdminJobPostingsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminJobPostingsRetrieveQueryKey = (id: string,) => {
    return [
    `/api/admin/job-postings/${id}/`
    ] as const;
    }


export const getAdminJobPostingsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminJobPostingsRetrieve>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobPostingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminJobPostingsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminJobPostingsRetrieve>>> = ({ signal }) => adminJobPostingsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminJobPostingsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminJobPostingsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminJobPostingsRetrieve>>>
export type AdminJobPostingsRetrieveQueryError = void


export function useAdminJobPostingsRetrieve<TData = Awaited<ReturnType<typeof adminJobPostingsRetrieve>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobPostingsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminJobPostingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminJobPostingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminJobPostingsRetrieve<TData = Awaited<ReturnType<typeof adminJobPostingsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobPostingsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminJobPostingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminJobPostingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminJobPostingsRetrieve<TData = Awaited<ReturnType<typeof adminJobPostingsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobPostingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminJobPostingsRetrieve<TData = Awaited<ReturnType<typeof adminJobPostingsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobPostingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminJobPostingsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminJobPostingsPartialUpdateUrl = (id: string,) => {




  return `/api/admin/job-postings/${id}/`
}

/**
 * Partial update on a job posting. Currently only supports the PENDING → OPEN approval transition: PATCH `{"status": "open"}`.
 */
export const adminJobPostingsPartialUpdate = async (id: string,
    patchedAdminJobPostingTransitionRequest?: PatchedAdminJobPostingTransitionRequest, options?: Parameters<typeof customFetch>[1]): Promise<_ApproveResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<_ApproveResponse>(getAdminJobPostingsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedAdminJobPostingTransitionRequest)
  }
);}





export const getAdminJobPostingsPartialUpdateMutationKey = () => ['adminJobPostingsPartialUpdate'] as const;

export const getAdminJobPostingsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminJobPostingsPartialUpdate>>, TError,AdminJobPostingsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminJobPostingsPartialUpdate>>, TError,AdminJobPostingsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminJobPostingsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminJobPostingsPartialUpdate>>, AdminJobPostingsPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  adminJobPostingsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminJobPostingsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminJobPostingsPartialUpdate>>>
    export type AdminJobPostingsPartialUpdateMutationBody = PatchedAdminJobPostingTransitionRequest | undefined
    export type AdminJobPostingsPartialUpdateMutationError = void
    export type AdminJobPostingsPartialUpdateMutationVariables = {id: string;data?: PatchedAdminJobPostingTransitionRequest}

    export const useAdminJobPostingsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminJobPostingsPartialUpdate>>, TError,AdminJobPostingsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminJobPostingsPartialUpdate>>,
        TError,
        AdminJobPostingsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminJobPostingsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getAdminJobPostingsAppliedByProListUrl = (proId: number,
    params?: AdminJobPostingsAppliedByProListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/job-postings/applied-by-pro/${proId}/?${stringifiedParams}` : `/api/admin/job-postings/applied-by-pro/${proId}/`
}

/**
 * List the job postings a given pro has applied to, with each row carrying that
 * pro's `application_stage` (APPLIED, SHIFT_OFFERED, JOB_OFFERED, ACCEPTED,
 * DECLINED, etc.).
 *
 * Lives in its own view class — rather than as an `@action` on AdminJobPostingView
 * — because spectacular's auto-pagination wrapping recognizes generics.ListAPIView
 * by convention. The same shape implemented as an @action with a URL-captured pro_id
 * is mis-inferred as a `_retrieve` (single object) endpoint, which produces a bare-
 * object response schema and trips the contract violation called out in
 * the `openapi-contract-fix` skill.
 */
export const adminJobPostingsAppliedByProList = async (proId: number,
    params?: AdminJobPostingsAppliedByProListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedAdminJobPostingWithApplicationStageList> => {

  return customFetch<PaginatedAdminJobPostingWithApplicationStageList>(getAdminJobPostingsAppliedByProListUrl(proId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminJobPostingsAppliedByProListInfiniteQueryKey = (proId: number,
    params?: AdminJobPostingsAppliedByProListParams,) => {
    return [
    'infinite', `/api/admin/job-postings/applied-by-pro/${proId}/`, ...(params ? [params] : [])
    ] as const;
    }

export const getAdminJobPostingsAppliedByProListQueryKey = (proId: number,
    params?: AdminJobPostingsAppliedByProListParams,) => {
    return [
    `/api/admin/job-postings/applied-by-pro/${proId}/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminJobPostingsAppliedByProListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>, AdminJobPostingsAppliedByProListParams['page']>, TError = void>(proId: number,
    params?: AdminJobPostingsAppliedByProListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>, TError, TData, QueryKey, AdminJobPostingsAppliedByProListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminJobPostingsAppliedByProListInfiniteQueryKey(proId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>, QueryKey, AdminJobPostingsAppliedByProListParams['page']> = ({ signal, pageParam }) => adminJobPostingsAppliedByProList(proId,{...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: proId !== null && proId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>, TError, TData, QueryKey, AdminJobPostingsAppliedByProListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminJobPostingsAppliedByProListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>>
export type AdminJobPostingsAppliedByProListInfiniteQueryError = void


export function useAdminJobPostingsAppliedByProListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>, AdminJobPostingsAppliedByProListParams['page']>, TError = void>(
 proId: number,
    params: undefined |  AdminJobPostingsAppliedByProListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>, TError, TData, QueryKey, AdminJobPostingsAppliedByProListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>,
          TError,
          Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminJobPostingsAppliedByProListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>, AdminJobPostingsAppliedByProListParams['page']>, TError = void>(
 proId: number,
    params?: AdminJobPostingsAppliedByProListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>, TError, TData, QueryKey, AdminJobPostingsAppliedByProListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>,
          TError,
          Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminJobPostingsAppliedByProListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>, AdminJobPostingsAppliedByProListParams['page']>, TError = void>(
 proId: number,
    params?: AdminJobPostingsAppliedByProListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>, TError, TData, QueryKey, AdminJobPostingsAppliedByProListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminJobPostingsAppliedByProListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>, AdminJobPostingsAppliedByProListParams['page']>, TError = void>(
 proId: number,
    params?: AdminJobPostingsAppliedByProListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>, TError, TData, QueryKey, AdminJobPostingsAppliedByProListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminJobPostingsAppliedByProListInfiniteQueryOptions(proId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminJobPostingsAppliedByProListQueryOptions = <TData = Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>, TError = void>(proId: number,
    params?: AdminJobPostingsAppliedByProListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminJobPostingsAppliedByProListQueryKey(proId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>> = ({ signal }) => adminJobPostingsAppliedByProList(proId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: proId !== null && proId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminJobPostingsAppliedByProListQueryResult = NonNullable<Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>>
export type AdminJobPostingsAppliedByProListQueryError = void


export function useAdminJobPostingsAppliedByProList<TData = Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>, TError = void>(
 proId: number,
    params: undefined |  AdminJobPostingsAppliedByProListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>,
          TError,
          Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminJobPostingsAppliedByProList<TData = Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>, TError = void>(
 proId: number,
    params?: AdminJobPostingsAppliedByProListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>,
          TError,
          Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminJobPostingsAppliedByProList<TData = Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>, TError = void>(
 proId: number,
    params?: AdminJobPostingsAppliedByProListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminJobPostingsAppliedByProList<TData = Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>, TError = void>(
 proId: number,
    params?: AdminJobPostingsAppliedByProListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobPostingsAppliedByProList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminJobPostingsAppliedByProListQueryOptions(proId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminLocationsOrganizationRemappingCreateUrl = () => {




  return `/api/admin/locations/organization-remapping/`
}

/**
 * Admin endpoint to move a location into a different organization or create a new one.
 */
export const adminLocationsOrganizationRemappingCreate = async (locationOrgRemapRequest: LocationOrgRemapRequest, options?: Parameters<typeof customFetch>[1]): Promise<LocationOrgRemap> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<LocationOrgRemap>(getAdminLocationsOrganizationRemappingCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(locationOrgRemapRequest)
  }
);}





export const getAdminLocationsOrganizationRemappingCreateMutationKey = () => ['adminLocationsOrganizationRemappingCreate'] as const;

export const getAdminLocationsOrganizationRemappingCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLocationsOrganizationRemappingCreate>>, TError,AdminLocationsOrganizationRemappingCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminLocationsOrganizationRemappingCreate>>, TError,AdminLocationsOrganizationRemappingCreateMutationVariables, TContext> => {

const mutationKey = getAdminLocationsOrganizationRemappingCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminLocationsOrganizationRemappingCreate>>, AdminLocationsOrganizationRemappingCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminLocationsOrganizationRemappingCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminLocationsOrganizationRemappingCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminLocationsOrganizationRemappingCreate>>>
    export type AdminLocationsOrganizationRemappingCreateMutationBody = LocationOrgRemapRequest
    export type AdminLocationsOrganizationRemappingCreateMutationError = void
    export type AdminLocationsOrganizationRemappingCreateMutationVariables = {data: LocationOrgRemapRequest}

    export const useAdminLocationsOrganizationRemappingCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLocationsOrganizationRemappingCreate>>, TError,AdminLocationsOrganizationRemappingCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminLocationsOrganizationRemappingCreate>>,
        TError,
        AdminLocationsOrganizationRemappingCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminLocationsOrganizationRemappingCreateMutationOptions(options), queryClient);
    }
    export const getAdminMatchDashboardAtRiskProsListUrl = (params?: AdminMatchDashboardAtRiskProsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/match-dashboard/at-risk-pros/?${stringifiedParams}` : `/api/admin/match-dashboard/at-risk-pros/`
}

/**
 * At-Risk Pros Command Center — pro-centric outreach queue (CORE-5955 / CORE-5956).
 *
 * Base path /api/admin/match-dashboard/at-risk-pros/. One row per pro across the cancellation /
 * inexperienced / dormant cohorts, dismissed pros excluded by default. Risk detection reuses
 * risky_pro_evaluator (lockstep with Match Command Center); see AtRiskProService.
 */
export const adminMatchDashboardAtRiskProsList = async (params?: AdminMatchDashboardAtRiskProsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedAtRiskProList> => {

  return customFetch<PaginatedAtRiskProList>(getAdminMatchDashboardAtRiskProsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminMatchDashboardAtRiskProsListInfiniteQueryKey = (params?: AdminMatchDashboardAtRiskProsListParams,) => {
    return [
    'infinite', `/api/admin/match-dashboard/at-risk-pros/`, ...(params ? [params] : [])
    ] as const;
    }

export const getAdminMatchDashboardAtRiskProsListQueryKey = (params?: AdminMatchDashboardAtRiskProsListParams,) => {
    return [
    `/api/admin/match-dashboard/at-risk-pros/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminMatchDashboardAtRiskProsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>, AdminMatchDashboardAtRiskProsListParams['page']>, TError = void>(params?: AdminMatchDashboardAtRiskProsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>, TError, TData, QueryKey, AdminMatchDashboardAtRiskProsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMatchDashboardAtRiskProsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>, QueryKey, AdminMatchDashboardAtRiskProsListParams['page']> = ({ signal, pageParam }) => adminMatchDashboardAtRiskProsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>, TError, TData, QueryKey, AdminMatchDashboardAtRiskProsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMatchDashboardAtRiskProsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>>
export type AdminMatchDashboardAtRiskProsListInfiniteQueryError = void


export function useAdminMatchDashboardAtRiskProsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>, AdminMatchDashboardAtRiskProsListParams['page']>, TError = void>(
 params: undefined |  AdminMatchDashboardAtRiskProsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>, TError, TData, QueryKey, AdminMatchDashboardAtRiskProsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardAtRiskProsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>, AdminMatchDashboardAtRiskProsListParams['page']>, TError = void>(
 params?: AdminMatchDashboardAtRiskProsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>, TError, TData, QueryKey, AdminMatchDashboardAtRiskProsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardAtRiskProsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>, AdminMatchDashboardAtRiskProsListParams['page']>, TError = void>(
 params?: AdminMatchDashboardAtRiskProsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>, TError, TData, QueryKey, AdminMatchDashboardAtRiskProsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminMatchDashboardAtRiskProsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>, AdminMatchDashboardAtRiskProsListParams['page']>, TError = void>(
 params?: AdminMatchDashboardAtRiskProsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>, TError, TData, QueryKey, AdminMatchDashboardAtRiskProsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMatchDashboardAtRiskProsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminMatchDashboardAtRiskProsListQueryOptions = <TData = Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>, TError = void>(params?: AdminMatchDashboardAtRiskProsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMatchDashboardAtRiskProsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>> = ({ signal }) => adminMatchDashboardAtRiskProsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMatchDashboardAtRiskProsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>>
export type AdminMatchDashboardAtRiskProsListQueryError = void


export function useAdminMatchDashboardAtRiskProsList<TData = Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>, TError = void>(
 params: undefined |  AdminMatchDashboardAtRiskProsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardAtRiskProsList<TData = Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>, TError = void>(
 params?: AdminMatchDashboardAtRiskProsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardAtRiskProsList<TData = Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>, TError = void>(
 params?: AdminMatchDashboardAtRiskProsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminMatchDashboardAtRiskProsList<TData = Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>, TError = void>(
 params?: AdminMatchDashboardAtRiskProsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMatchDashboardAtRiskProsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminMatchDashboardAtRiskProsDismissCreateUrl = (id: number,) => {




  return `/api/admin/match-dashboard/at-risk-pros/${id}/dismiss/`
}

/**
 * At-Risk Pros Command Center — pro-centric outreach queue (CORE-5955 / CORE-5956).
 *
 * Base path /api/admin/match-dashboard/at-risk-pros/. One row per pro across the cancellation /
 * inexperienced / dormant cohorts, dismissed pros excluded by default. Risk detection reuses
 * risky_pro_evaluator (lockstep with Match Command Center); see AtRiskProService.
 */
export const adminMatchDashboardAtRiskProsDismissCreate = async (id: number,
    atRiskProDismissRequestRequest?: AtRiskProDismissRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<AtRiskProDismissResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AtRiskProDismissResponse>(getAdminMatchDashboardAtRiskProsDismissCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(atRiskProDismissRequestRequest)
  }
);}





export const getAdminMatchDashboardAtRiskProsDismissCreateMutationKey = () => ['adminMatchDashboardAtRiskProsDismissCreate'] as const;

export const getAdminMatchDashboardAtRiskProsDismissCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsDismissCreate>>, TError,AdminMatchDashboardAtRiskProsDismissCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsDismissCreate>>, TError,AdminMatchDashboardAtRiskProsDismissCreateMutationVariables, TContext> => {

const mutationKey = getAdminMatchDashboardAtRiskProsDismissCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsDismissCreate>>, AdminMatchDashboardAtRiskProsDismissCreateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  adminMatchDashboardAtRiskProsDismissCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminMatchDashboardAtRiskProsDismissCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsDismissCreate>>>
    export type AdminMatchDashboardAtRiskProsDismissCreateMutationBody = AtRiskProDismissRequestRequest | undefined
    export type AdminMatchDashboardAtRiskProsDismissCreateMutationError = void
    export type AdminMatchDashboardAtRiskProsDismissCreateMutationVariables = {id: number;data?: AtRiskProDismissRequestRequest}

    export const useAdminMatchDashboardAtRiskProsDismissCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsDismissCreate>>, TError,AdminMatchDashboardAtRiskProsDismissCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsDismissCreate>>,
        TError,
        AdminMatchDashboardAtRiskProsDismissCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminMatchDashboardAtRiskProsDismissCreateMutationOptions(options), queryClient);
    }
    export const getAdminMatchDashboardAtRiskProsFilterOptionsRetrieveUrl = (params?: AdminMatchDashboardAtRiskProsFilterOptionsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/match-dashboard/at-risk-pros/filter-options/?${stringifiedParams}` : `/api/admin/match-dashboard/at-risk-pros/filter-options/`
}

/**
 * At-Risk Pros Command Center — pro-centric outreach queue (CORE-5955 / CORE-5956).
 *
 * Base path /api/admin/match-dashboard/at-risk-pros/. One row per pro across the cancellation /
 * inexperienced / dormant cohorts, dismissed pros excluded by default. Risk detection reuses
 * risky_pro_evaluator (lockstep with Match Command Center); see AtRiskProService.
 */
export const adminMatchDashboardAtRiskProsFilterOptionsRetrieve = async (params?: AdminMatchDashboardAtRiskProsFilterOptionsRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<AtRiskProFilterOptions> => {

  return customFetch<AtRiskProFilterOptions>(getAdminMatchDashboardAtRiskProsFilterOptionsRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminMatchDashboardAtRiskProsFilterOptionsRetrieveQueryKey = (params?: AdminMatchDashboardAtRiskProsFilterOptionsRetrieveParams,) => {
    return [
    `/api/admin/match-dashboard/at-risk-pros/filter-options/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminMatchDashboardAtRiskProsFilterOptionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsFilterOptionsRetrieve>>, TError = void>(params?: AdminMatchDashboardAtRiskProsFilterOptionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsFilterOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMatchDashboardAtRiskProsFilterOptionsRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsFilterOptionsRetrieve>>> = ({ signal }) => adminMatchDashboardAtRiskProsFilterOptionsRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsFilterOptionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMatchDashboardAtRiskProsFilterOptionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsFilterOptionsRetrieve>>>
export type AdminMatchDashboardAtRiskProsFilterOptionsRetrieveQueryError = void


export function useAdminMatchDashboardAtRiskProsFilterOptionsRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsFilterOptionsRetrieve>>, TError = void>(
 params: undefined |  AdminMatchDashboardAtRiskProsFilterOptionsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsFilterOptionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsFilterOptionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsFilterOptionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardAtRiskProsFilterOptionsRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsFilterOptionsRetrieve>>, TError = void>(
 params?: AdminMatchDashboardAtRiskProsFilterOptionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsFilterOptionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsFilterOptionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsFilterOptionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardAtRiskProsFilterOptionsRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsFilterOptionsRetrieve>>, TError = void>(
 params?: AdminMatchDashboardAtRiskProsFilterOptionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsFilterOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminMatchDashboardAtRiskProsFilterOptionsRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsFilterOptionsRetrieve>>, TError = void>(
 params?: AdminMatchDashboardAtRiskProsFilterOptionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsFilterOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMatchDashboardAtRiskProsFilterOptionsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminMatchDashboardAtRiskProsSummaryRetrieveUrl = (params?: AdminMatchDashboardAtRiskProsSummaryRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/match-dashboard/at-risk-pros/summary/?${stringifiedParams}` : `/api/admin/match-dashboard/at-risk-pros/summary/`
}

/**
 * At-Risk Pros Command Center — pro-centric outreach queue (CORE-5955 / CORE-5956).
 *
 * Base path /api/admin/match-dashboard/at-risk-pros/. One row per pro across the cancellation /
 * inexperienced / dormant cohorts, dismissed pros excluded by default. Risk detection reuses
 * risky_pro_evaluator (lockstep with Match Command Center); see AtRiskProService.
 */
export const adminMatchDashboardAtRiskProsSummaryRetrieve = async (params?: AdminMatchDashboardAtRiskProsSummaryRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<AtRiskProSummary> => {

  return customFetch<AtRiskProSummary>(getAdminMatchDashboardAtRiskProsSummaryRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminMatchDashboardAtRiskProsSummaryRetrieveQueryKey = (params?: AdminMatchDashboardAtRiskProsSummaryRetrieveParams,) => {
    return [
    `/api/admin/match-dashboard/at-risk-pros/summary/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminMatchDashboardAtRiskProsSummaryRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsSummaryRetrieve>>, TError = void>(params?: AdminMatchDashboardAtRiskProsSummaryRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMatchDashboardAtRiskProsSummaryRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsSummaryRetrieve>>> = ({ signal }) => adminMatchDashboardAtRiskProsSummaryRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsSummaryRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMatchDashboardAtRiskProsSummaryRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsSummaryRetrieve>>>
export type AdminMatchDashboardAtRiskProsSummaryRetrieveQueryError = void


export function useAdminMatchDashboardAtRiskProsSummaryRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsSummaryRetrieve>>, TError = void>(
 params: undefined |  AdminMatchDashboardAtRiskProsSummaryRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsSummaryRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsSummaryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsSummaryRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardAtRiskProsSummaryRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsSummaryRetrieve>>, TError = void>(
 params?: AdminMatchDashboardAtRiskProsSummaryRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsSummaryRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsSummaryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsSummaryRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMatchDashboardAtRiskProsSummaryRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsSummaryRetrieve>>, TError = void>(
 params?: AdminMatchDashboardAtRiskProsSummaryRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminMatchDashboardAtRiskProsSummaryRetrieve<TData = Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsSummaryRetrieve>>, TError = void>(
 params?: AdminMatchDashboardAtRiskProsSummaryRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMatchDashboardAtRiskProsSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMatchDashboardAtRiskProsSummaryRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminProBlockListUrl = (params?: AdminProBlockListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/pro-block/?${stringifiedParams}` : `/api/admin/pro-block/`
}

/**
 * This API is designed for gigpro admins to allow block/unblock Pros.
 *
 * A GigsterBlock represents a database record which is used to determine if a Pro is blocked in a location or not
 */
export const adminProBlockList = async (params?: AdminProBlockListParams, options?: Parameters<typeof customFetch>[1]): Promise<GigsterBlockReadOnly[]> => {

  return customFetch<GigsterBlockReadOnly[]>(getAdminProBlockListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminProBlockListQueryKey = (params?: AdminProBlockListParams,) => {
    return [
    `/api/admin/pro-block/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminProBlockListQueryOptions = <TData = Awaited<ReturnType<typeof adminProBlockList>>, TError = void>(params?: AdminProBlockListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminProBlockList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminProBlockListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminProBlockList>>> = ({ signal }) => adminProBlockList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminProBlockList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminProBlockListQueryResult = NonNullable<Awaited<ReturnType<typeof adminProBlockList>>>
export type AdminProBlockListQueryError = void


export function useAdminProBlockList<TData = Awaited<ReturnType<typeof adminProBlockList>>, TError = void>(
 params: undefined |  AdminProBlockListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminProBlockList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminProBlockList>>,
          TError,
          Awaited<ReturnType<typeof adminProBlockList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminProBlockList<TData = Awaited<ReturnType<typeof adminProBlockList>>, TError = void>(
 params?: AdminProBlockListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminProBlockList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminProBlockList>>,
          TError,
          Awaited<ReturnType<typeof adminProBlockList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminProBlockList<TData = Awaited<ReturnType<typeof adminProBlockList>>, TError = void>(
 params?: AdminProBlockListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminProBlockList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminProBlockList<TData = Awaited<ReturnType<typeof adminProBlockList>>, TError = void>(
 params?: AdminProBlockListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminProBlockList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminProBlockListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminProBlockCreateUrl = () => {




  return `/api/admin/pro-block/`
}

/**
 * This API is designed for gigpro admins to allow block/unblock Pros.
 *
 * A GigsterBlock represents a database record which is used to determine if a Pro is blocked in a location or not
 */
export const adminProBlockCreate = async (gigsterBlockMultiLocationRequest: GigsterBlockMultiLocationRequest, options?: Parameters<typeof customFetch>[1]): Promise<GigsterBlockMultiLocation> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<GigsterBlockMultiLocation>(getAdminProBlockCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(gigsterBlockMultiLocationRequest)
  }
);}





export const getAdminProBlockCreateMutationKey = () => ['adminProBlockCreate'] as const;

export const getAdminProBlockCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProBlockCreate>>, TError,AdminProBlockCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminProBlockCreate>>, TError,AdminProBlockCreateMutationVariables, TContext> => {

const mutationKey = getAdminProBlockCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminProBlockCreate>>, AdminProBlockCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminProBlockCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminProBlockCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminProBlockCreate>>>
    export type AdminProBlockCreateMutationBody = GigsterBlockMultiLocationRequest
    export type AdminProBlockCreateMutationError = void
    export type AdminProBlockCreateMutationVariables = {data: GigsterBlockMultiLocationRequest}

    export const useAdminProBlockCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProBlockCreate>>, TError,AdminProBlockCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminProBlockCreate>>,
        TError,
        AdminProBlockCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminProBlockCreateMutationOptions(options), queryClient);
    }
    export const getAdminProBlockDestroyUrl = (id: number,) => {




  return `/api/admin/pro-block/${id}/`
}

/**
 * This API is designed for gigpro admins to allow block/unblock Pros.
 *
 * A GigsterBlock represents a database record which is used to determine if a Pro is blocked in a location or not
 */
export const adminProBlockDestroy = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getAdminProBlockDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminProBlockDestroyMutationKey = () => ['adminProBlockDestroy'] as const;

export const getAdminProBlockDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProBlockDestroy>>, TError,AdminProBlockDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminProBlockDestroy>>, TError,AdminProBlockDestroyMutationVariables, TContext> => {

const mutationKey = getAdminProBlockDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminProBlockDestroy>>, AdminProBlockDestroyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  adminProBlockDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminProBlockDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminProBlockDestroy>>>

    export type AdminProBlockDestroyMutationError = void
    export type AdminProBlockDestroyMutationVariables = {id: number}

    export const useAdminProBlockDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProBlockDestroy>>, TError,AdminProBlockDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminProBlockDestroy>>,
        TError,
        AdminProBlockDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminProBlockDestroyMutationOptions(options), queryClient);
    }
    export const getAdminProPaymentsCreateUrl = () => {




  return `/api/admin/pro-payments/`
}

export const adminProPaymentsCreate = async (proPaymentCreateRequest: ProPaymentCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<ProPaymentCreate> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ProPaymentCreate>(getAdminProPaymentsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(proPaymentCreateRequest)
  }
);}





export const getAdminProPaymentsCreateMutationKey = () => ['adminProPaymentsCreate'] as const;

export const getAdminProPaymentsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProPaymentsCreate>>, TError,AdminProPaymentsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminProPaymentsCreate>>, TError,AdminProPaymentsCreateMutationVariables, TContext> => {

const mutationKey = getAdminProPaymentsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminProPaymentsCreate>>, AdminProPaymentsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminProPaymentsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminProPaymentsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminProPaymentsCreate>>>
    export type AdminProPaymentsCreateMutationBody = ProPaymentCreateRequest
    export type AdminProPaymentsCreateMutationError = void
    export type AdminProPaymentsCreateMutationVariables = {data: ProPaymentCreateRequest}

    export const useAdminProPaymentsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProPaymentsCreate>>, TError,AdminProPaymentsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminProPaymentsCreate>>,
        TError,
        AdminProPaymentsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminProPaymentsCreateMutationOptions(options), queryClient);
    }
    export const getAdminReferralCodeListUrl = (params?: AdminReferralCodeListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/referral-code/?${stringifiedParams}` : `/api/admin/referral-code/`
}

/**
 * A ManualManagementOfReferralCodesView represents a ReferralCode record assigned manually to a business user.
 *
 * This API is designed for gigpro admins to allow create manual referral codes for business partners.
 */
export const adminReferralCodeList = async (params?: AdminReferralCodeListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedManualReferralCodeList> => {

  return customFetch<PaginatedManualReferralCodeList>(getAdminReferralCodeListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminReferralCodeListInfiniteQueryKey = (params?: AdminReferralCodeListParams,) => {
    return [
    'infinite', `/api/admin/referral-code/`, ...(params ? [params] : [])
    ] as const;
    }

export const getAdminReferralCodeListQueryKey = (params?: AdminReferralCodeListParams,) => {
    return [
    `/api/admin/referral-code/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminReferralCodeListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof adminReferralCodeList>>, AdminReferralCodeListParams['page']>, TError = void>(params?: AdminReferralCodeListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminReferralCodeList>>, TError, TData, QueryKey, AdminReferralCodeListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminReferralCodeListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminReferralCodeList>>, QueryKey, AdminReferralCodeListParams['page']> = ({ signal, pageParam }) => adminReferralCodeList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminReferralCodeList>>, TError, TData, QueryKey, AdminReferralCodeListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminReferralCodeListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminReferralCodeList>>>
export type AdminReferralCodeListInfiniteQueryError = void


export function useAdminReferralCodeListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminReferralCodeList>>, AdminReferralCodeListParams['page']>, TError = void>(
 params: undefined |  AdminReferralCodeListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminReferralCodeList>>, TError, TData, QueryKey, AdminReferralCodeListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminReferralCodeList>>,
          TError,
          Awaited<ReturnType<typeof adminReferralCodeList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminReferralCodeListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminReferralCodeList>>, AdminReferralCodeListParams['page']>, TError = void>(
 params?: AdminReferralCodeListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminReferralCodeList>>, TError, TData, QueryKey, AdminReferralCodeListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminReferralCodeList>>,
          TError,
          Awaited<ReturnType<typeof adminReferralCodeList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminReferralCodeListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminReferralCodeList>>, AdminReferralCodeListParams['page']>, TError = void>(
 params?: AdminReferralCodeListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminReferralCodeList>>, TError, TData, QueryKey, AdminReferralCodeListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminReferralCodeListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminReferralCodeList>>, AdminReferralCodeListParams['page']>, TError = void>(
 params?: AdminReferralCodeListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminReferralCodeList>>, TError, TData, QueryKey, AdminReferralCodeListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminReferralCodeListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminReferralCodeListQueryOptions = <TData = Awaited<ReturnType<typeof adminReferralCodeList>>, TError = void>(params?: AdminReferralCodeListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReferralCodeList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminReferralCodeListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminReferralCodeList>>> = ({ signal }) => adminReferralCodeList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminReferralCodeList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminReferralCodeListQueryResult = NonNullable<Awaited<ReturnType<typeof adminReferralCodeList>>>
export type AdminReferralCodeListQueryError = void


export function useAdminReferralCodeList<TData = Awaited<ReturnType<typeof adminReferralCodeList>>, TError = void>(
 params: undefined |  AdminReferralCodeListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReferralCodeList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminReferralCodeList>>,
          TError,
          Awaited<ReturnType<typeof adminReferralCodeList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminReferralCodeList<TData = Awaited<ReturnType<typeof adminReferralCodeList>>, TError = void>(
 params?: AdminReferralCodeListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReferralCodeList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminReferralCodeList>>,
          TError,
          Awaited<ReturnType<typeof adminReferralCodeList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminReferralCodeList<TData = Awaited<ReturnType<typeof adminReferralCodeList>>, TError = void>(
 params?: AdminReferralCodeListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReferralCodeList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminReferralCodeList<TData = Awaited<ReturnType<typeof adminReferralCodeList>>, TError = void>(
 params?: AdminReferralCodeListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReferralCodeList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminReferralCodeListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminReferralCodeCreateUrl = () => {




  return `/api/admin/referral-code/`
}

/**
 * A ManualManagementOfReferralCodesView represents a ReferralCode record assigned manually to a business user.
 *
 * This API is designed for gigpro admins to allow create manual referral codes for business partners.
 */
export const adminReferralCodeCreate = async (createManualReferralCodeRequest: CreateManualReferralCodeRequest, options?: Parameters<typeof customFetch>[1]): Promise<CreateManualReferralCode> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<CreateManualReferralCode>(getAdminReferralCodeCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createManualReferralCodeRequest)
  }
);}





export const getAdminReferralCodeCreateMutationKey = () => ['adminReferralCodeCreate'] as const;

export const getAdminReferralCodeCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminReferralCodeCreate>>, TError,AdminReferralCodeCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminReferralCodeCreate>>, TError,AdminReferralCodeCreateMutationVariables, TContext> => {

const mutationKey = getAdminReferralCodeCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminReferralCodeCreate>>, AdminReferralCodeCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminReferralCodeCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminReferralCodeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminReferralCodeCreate>>>
    export type AdminReferralCodeCreateMutationBody = CreateManualReferralCodeRequest
    export type AdminReferralCodeCreateMutationError = void
    export type AdminReferralCodeCreateMutationVariables = {data: CreateManualReferralCodeRequest}

    export const useAdminReferralCodeCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminReferralCodeCreate>>, TError,AdminReferralCodeCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminReferralCodeCreate>>,
        TError,
        AdminReferralCodeCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminReferralCodeCreateMutationOptions(options), queryClient);
    }
    export const getAdminReferralCodeSignupCreateUrl = () => {




  return `/api/admin/referral-code-signup/`
}

/**
 * A ManualAssignOfReferralsView represents a ReferralCodeCompletion record assigned manually to a business user.
 *
 * This API is designed for gigpro admins to allow create manual assign referrals for business.
 */
export const adminReferralCodeSignupCreate = async (manualAssignReferralCreateRequest: ManualAssignReferralCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<ManualAssignReferralCreate> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ManualAssignReferralCreate>(getAdminReferralCodeSignupCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(manualAssignReferralCreateRequest)
  }
);}





export const getAdminReferralCodeSignupCreateMutationKey = () => ['adminReferralCodeSignupCreate'] as const;

export const getAdminReferralCodeSignupCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminReferralCodeSignupCreate>>, TError,AdminReferralCodeSignupCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminReferralCodeSignupCreate>>, TError,AdminReferralCodeSignupCreateMutationVariables, TContext> => {

const mutationKey = getAdminReferralCodeSignupCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminReferralCodeSignupCreate>>, AdminReferralCodeSignupCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminReferralCodeSignupCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminReferralCodeSignupCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminReferralCodeSignupCreate>>>
    export type AdminReferralCodeSignupCreateMutationBody = ManualAssignReferralCreateRequest
    export type AdminReferralCodeSignupCreateMutationError = void
    export type AdminReferralCodeSignupCreateMutationVariables = {data: ManualAssignReferralCreateRequest}

    export const useAdminReferralCodeSignupCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminReferralCodeSignupCreate>>, TError,AdminReferralCodeSignupCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminReferralCodeSignupCreate>>,
        TError,
        AdminReferralCodeSignupCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminReferralCodeSignupCreateMutationOptions(options), queryClient);
    }
    export const getAdminReferralCodeSignupDestroyUrl = (id: number,) => {




  return `/api/admin/referral-code-signup/${id}/`
}

/**
 * A ManualAssignOfReferralsView represents a ReferralCodeCompletion record assigned manually to a business user.
 *
 * This API is designed for gigpro admins to allow create manual assign referrals for business.
 */
export const adminReferralCodeSignupDestroy = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getAdminReferralCodeSignupDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminReferralCodeSignupDestroyMutationKey = () => ['adminReferralCodeSignupDestroy'] as const;

export const getAdminReferralCodeSignupDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminReferralCodeSignupDestroy>>, TError,AdminReferralCodeSignupDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminReferralCodeSignupDestroy>>, TError,AdminReferralCodeSignupDestroyMutationVariables, TContext> => {

const mutationKey = getAdminReferralCodeSignupDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminReferralCodeSignupDestroy>>, AdminReferralCodeSignupDestroyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  adminReferralCodeSignupDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminReferralCodeSignupDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminReferralCodeSignupDestroy>>>

    export type AdminReferralCodeSignupDestroyMutationError = void
    export type AdminReferralCodeSignupDestroyMutationVariables = {id: number}

    export const useAdminReferralCodeSignupDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminReferralCodeSignupDestroy>>, TError,AdminReferralCodeSignupDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminReferralCodeSignupDestroy>>,
        TError,
        AdminReferralCodeSignupDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminReferralCodeSignupDestroyMutationOptions(options), queryClient);
    }
    export const getAdminReferralCodeRetrieveUrl = (id: number,) => {




  return `/api/admin/referral-code/${id}/`
}

/**
 * A ManualManagementOfReferralCodesView represents a ReferralCode record assigned manually to a business user.
 *
 * This API is designed for gigpro admins to allow create manual referral codes for business partners.
 */
export const adminReferralCodeRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<ManualReferralCode> => {

  return customFetch<ManualReferralCode>(getAdminReferralCodeRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminReferralCodeRetrieveQueryKey = (id: number,) => {
    return [
    `/api/admin/referral-code/${id}/`
    ] as const;
    }


export const getAdminReferralCodeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminReferralCodeRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReferralCodeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminReferralCodeRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminReferralCodeRetrieve>>> = ({ signal }) => adminReferralCodeRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminReferralCodeRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminReferralCodeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminReferralCodeRetrieve>>>
export type AdminReferralCodeRetrieveQueryError = void


export function useAdminReferralCodeRetrieve<TData = Awaited<ReturnType<typeof adminReferralCodeRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReferralCodeRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminReferralCodeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminReferralCodeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminReferralCodeRetrieve<TData = Awaited<ReturnType<typeof adminReferralCodeRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReferralCodeRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminReferralCodeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminReferralCodeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminReferralCodeRetrieve<TData = Awaited<ReturnType<typeof adminReferralCodeRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReferralCodeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminReferralCodeRetrieve<TData = Awaited<ReturnType<typeof adminReferralCodeRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReferralCodeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminReferralCodeRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminReferralCodeUpdateUrl = (id: number,) => {




  return `/api/admin/referral-code/${id}/`
}

/**
 * A ManualManagementOfReferralCodesView represents a ReferralCode record assigned manually to a business user.
 *
 * This API is designed for gigpro admins to allow create manual referral codes for business partners.
 */
export const adminReferralCodeUpdate = async (id: number,
    updateManualReferralCodeRequest?: UpdateManualReferralCodeRequest, options?: Parameters<typeof customFetch>[1]): Promise<UpdateManualReferralCode> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<UpdateManualReferralCode>(getAdminReferralCodeUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateManualReferralCodeRequest)
  }
);}





export const getAdminReferralCodeUpdateMutationKey = () => ['adminReferralCodeUpdate'] as const;

export const getAdminReferralCodeUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminReferralCodeUpdate>>, TError,AdminReferralCodeUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminReferralCodeUpdate>>, TError,AdminReferralCodeUpdateMutationVariables, TContext> => {

const mutationKey = getAdminReferralCodeUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminReferralCodeUpdate>>, AdminReferralCodeUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  adminReferralCodeUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminReferralCodeUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminReferralCodeUpdate>>>
    export type AdminReferralCodeUpdateMutationBody = UpdateManualReferralCodeRequest | undefined
    export type AdminReferralCodeUpdateMutationError = void
    export type AdminReferralCodeUpdateMutationVariables = {id: number;data?: UpdateManualReferralCodeRequest}

    export const useAdminReferralCodeUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminReferralCodeUpdate>>, TError,AdminReferralCodeUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminReferralCodeUpdate>>,
        TError,
        AdminReferralCodeUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminReferralCodeUpdateMutationOptions(options), queryClient);
    }
    export const getAdminReferralCodePartialUpdateUrl = (id: number,) => {




  return `/api/admin/referral-code/${id}/`
}

/**
 * A ManualManagementOfReferralCodesView represents a ReferralCode record assigned manually to a business user.
 *
 * This API is designed for gigpro admins to allow create manual referral codes for business partners.
 */
export const adminReferralCodePartialUpdate = async (id: number,
    patchedManualReferralCodeRequest?: PatchedManualReferralCodeRequest, options?: Parameters<typeof customFetch>[1]): Promise<ManualReferralCode> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ManualReferralCode>(getAdminReferralCodePartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedManualReferralCodeRequest)
  }
);}





export const getAdminReferralCodePartialUpdateMutationKey = () => ['adminReferralCodePartialUpdate'] as const;

export const getAdminReferralCodePartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminReferralCodePartialUpdate>>, TError,AdminReferralCodePartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminReferralCodePartialUpdate>>, TError,AdminReferralCodePartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminReferralCodePartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminReferralCodePartialUpdate>>, AdminReferralCodePartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  adminReferralCodePartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminReferralCodePartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminReferralCodePartialUpdate>>>
    export type AdminReferralCodePartialUpdateMutationBody = PatchedManualReferralCodeRequest | undefined
    export type AdminReferralCodePartialUpdateMutationError = void
    export type AdminReferralCodePartialUpdateMutationVariables = {id: number;data?: PatchedManualReferralCodeRequest}

    export const useAdminReferralCodePartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminReferralCodePartialUpdate>>, TError,AdminReferralCodePartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminReferralCodePartialUpdate>>,
        TError,
        AdminReferralCodePartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminReferralCodePartialUpdateMutationOptions(options), queryClient);
    }
    export const getAdminSuspensionsListUrl = (params?: AdminSuspensionsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/suspensions/?${stringifiedParams}` : `/api/admin/suspensions/`
}

/**
 * Pro suspension records for policy violations such as late cancellations
 * or no-shows.
 *
 * Admins can view, create, and filter suspensions. Active suspensions block
 * a pro from applying to gigs.
 */
export const adminSuspensionsList = async (params?: AdminSuspensionsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedSuspensionList> => {

  return customFetch<PaginatedSuspensionList>(getAdminSuspensionsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminSuspensionsListInfiniteQueryKey = (params?: AdminSuspensionsListParams,) => {
    return [
    'infinite', `/api/admin/suspensions/`, ...(params ? [params] : [])
    ] as const;
    }

export const getAdminSuspensionsListQueryKey = (params?: AdminSuspensionsListParams,) => {
    return [
    `/api/admin/suspensions/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminSuspensionsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof adminSuspensionsList>>, AdminSuspensionsListParams['page']>, TError = void>(params?: AdminSuspensionsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminSuspensionsList>>, TError, TData, QueryKey, AdminSuspensionsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminSuspensionsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminSuspensionsList>>, QueryKey, AdminSuspensionsListParams['page']> = ({ signal, pageParam }) => adminSuspensionsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminSuspensionsList>>, TError, TData, QueryKey, AdminSuspensionsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminSuspensionsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminSuspensionsList>>>
export type AdminSuspensionsListInfiniteQueryError = void


export function useAdminSuspensionsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminSuspensionsList>>, AdminSuspensionsListParams['page']>, TError = void>(
 params: undefined |  AdminSuspensionsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminSuspensionsList>>, TError, TData, QueryKey, AdminSuspensionsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminSuspensionsList>>,
          TError,
          Awaited<ReturnType<typeof adminSuspensionsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminSuspensionsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminSuspensionsList>>, AdminSuspensionsListParams['page']>, TError = void>(
 params?: AdminSuspensionsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminSuspensionsList>>, TError, TData, QueryKey, AdminSuspensionsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminSuspensionsList>>,
          TError,
          Awaited<ReturnType<typeof adminSuspensionsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminSuspensionsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminSuspensionsList>>, AdminSuspensionsListParams['page']>, TError = void>(
 params?: AdminSuspensionsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminSuspensionsList>>, TError, TData, QueryKey, AdminSuspensionsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminSuspensionsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminSuspensionsList>>, AdminSuspensionsListParams['page']>, TError = void>(
 params?: AdminSuspensionsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminSuspensionsList>>, TError, TData, QueryKey, AdminSuspensionsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminSuspensionsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminSuspensionsListQueryOptions = <TData = Awaited<ReturnType<typeof adminSuspensionsList>>, TError = void>(params?: AdminSuspensionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSuspensionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminSuspensionsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminSuspensionsList>>> = ({ signal }) => adminSuspensionsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminSuspensionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminSuspensionsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminSuspensionsList>>>
export type AdminSuspensionsListQueryError = void


export function useAdminSuspensionsList<TData = Awaited<ReturnType<typeof adminSuspensionsList>>, TError = void>(
 params: undefined |  AdminSuspensionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSuspensionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminSuspensionsList>>,
          TError,
          Awaited<ReturnType<typeof adminSuspensionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminSuspensionsList<TData = Awaited<ReturnType<typeof adminSuspensionsList>>, TError = void>(
 params?: AdminSuspensionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSuspensionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminSuspensionsList>>,
          TError,
          Awaited<ReturnType<typeof adminSuspensionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminSuspensionsList<TData = Awaited<ReturnType<typeof adminSuspensionsList>>, TError = void>(
 params?: AdminSuspensionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSuspensionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminSuspensionsList<TData = Awaited<ReturnType<typeof adminSuspensionsList>>, TError = void>(
 params?: AdminSuspensionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSuspensionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminSuspensionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminSuspensionsCreateUrl = () => {




  return `/api/admin/suspensions/`
}

/**
 * Pro suspension records for policy violations such as late cancellations
 * or no-shows.
 *
 * Admins can view, create, and filter suspensions. Active suspensions block
 * a pro from applying to gigs.
 */
export const adminSuspensionsCreate = async (suspensionRequest: SuspensionRequest, options?: Parameters<typeof customFetch>[1]): Promise<Suspension> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Suspension>(getAdminSuspensionsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(suspensionRequest)
  }
);}





export const getAdminSuspensionsCreateMutationKey = () => ['adminSuspensionsCreate'] as const;

export const getAdminSuspensionsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSuspensionsCreate>>, TError,AdminSuspensionsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminSuspensionsCreate>>, TError,AdminSuspensionsCreateMutationVariables, TContext> => {

const mutationKey = getAdminSuspensionsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminSuspensionsCreate>>, AdminSuspensionsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminSuspensionsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminSuspensionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminSuspensionsCreate>>>
    export type AdminSuspensionsCreateMutationBody = SuspensionRequest
    export type AdminSuspensionsCreateMutationError = void
    export type AdminSuspensionsCreateMutationVariables = {data: SuspensionRequest}

    export const useAdminSuspensionsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSuspensionsCreate>>, TError,AdminSuspensionsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminSuspensionsCreate>>,
        TError,
        AdminSuspensionsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminSuspensionsCreateMutationOptions(options), queryClient);
    }
    export const getAdminSuspensionsRetrieveUrl = (id: number,) => {




  return `/api/admin/suspensions/${id}/`
}

/**
 * Pro suspension records for policy violations such as late cancellations
 * or no-shows.
 *
 * Admins can view, create, and filter suspensions. Active suspensions block
 * a pro from applying to gigs.
 */
export const adminSuspensionsRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<Suspension> => {

  return customFetch<Suspension>(getAdminSuspensionsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminSuspensionsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/admin/suspensions/${id}/`
    ] as const;
    }


export const getAdminSuspensionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminSuspensionsRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSuspensionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminSuspensionsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminSuspensionsRetrieve>>> = ({ signal }) => adminSuspensionsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminSuspensionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminSuspensionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminSuspensionsRetrieve>>>
export type AdminSuspensionsRetrieveQueryError = void


export function useAdminSuspensionsRetrieve<TData = Awaited<ReturnType<typeof adminSuspensionsRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSuspensionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminSuspensionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminSuspensionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminSuspensionsRetrieve<TData = Awaited<ReturnType<typeof adminSuspensionsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSuspensionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminSuspensionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminSuspensionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminSuspensionsRetrieve<TData = Awaited<ReturnType<typeof adminSuspensionsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSuspensionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminSuspensionsRetrieve<TData = Awaited<ReturnType<typeof adminSuspensionsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSuspensionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminSuspensionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminSuspensionsUpdateUrl = (id: number,) => {




  return `/api/admin/suspensions/${id}/`
}

/**
 * Pro suspension records for policy violations such as late cancellations
 * or no-shows.
 *
 * Admins can view, create, and filter suspensions. Active suspensions block
 * a pro from applying to gigs.
 */
export const adminSuspensionsUpdate = async (id: number,
    suspensionUpdateRequest: SuspensionUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<SuspensionUpdate> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<SuspensionUpdate>(getAdminSuspensionsUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(suspensionUpdateRequest)
  }
);}





export const getAdminSuspensionsUpdateMutationKey = () => ['adminSuspensionsUpdate'] as const;

export const getAdminSuspensionsUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSuspensionsUpdate>>, TError,AdminSuspensionsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminSuspensionsUpdate>>, TError,AdminSuspensionsUpdateMutationVariables, TContext> => {

const mutationKey = getAdminSuspensionsUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminSuspensionsUpdate>>, AdminSuspensionsUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  adminSuspensionsUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminSuspensionsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminSuspensionsUpdate>>>
    export type AdminSuspensionsUpdateMutationBody = SuspensionUpdateRequest
    export type AdminSuspensionsUpdateMutationError = void
    export type AdminSuspensionsUpdateMutationVariables = {id: number;data: SuspensionUpdateRequest}

    export const useAdminSuspensionsUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSuspensionsUpdate>>, TError,AdminSuspensionsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminSuspensionsUpdate>>,
        TError,
        AdminSuspensionsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminSuspensionsUpdateMutationOptions(options), queryClient);
    }
    export const getAdminSuspensionsPartialUpdateUrl = (id: number,) => {




  return `/api/admin/suspensions/${id}/`
}

/**
 * Pro suspension records for policy violations such as late cancellations
 * or no-shows.
 *
 * Admins can view, create, and filter suspensions. Active suspensions block
 * a pro from applying to gigs.
 */
export const adminSuspensionsPartialUpdate = async (id: number,
    patchedSuspensionRequest?: PatchedSuspensionRequest, options?: Parameters<typeof customFetch>[1]): Promise<Suspension> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Suspension>(getAdminSuspensionsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedSuspensionRequest)
  }
);}





export const getAdminSuspensionsPartialUpdateMutationKey = () => ['adminSuspensionsPartialUpdate'] as const;

export const getAdminSuspensionsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSuspensionsPartialUpdate>>, TError,AdminSuspensionsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminSuspensionsPartialUpdate>>, TError,AdminSuspensionsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminSuspensionsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminSuspensionsPartialUpdate>>, AdminSuspensionsPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  adminSuspensionsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminSuspensionsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminSuspensionsPartialUpdate>>>
    export type AdminSuspensionsPartialUpdateMutationBody = PatchedSuspensionRequest | undefined
    export type AdminSuspensionsPartialUpdateMutationError = void
    export type AdminSuspensionsPartialUpdateMutationVariables = {id: number;data?: PatchedSuspensionRequest}

    export const useAdminSuspensionsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSuspensionsPartialUpdate>>, TError,AdminSuspensionsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminSuspensionsPartialUpdate>>,
        TError,
        AdminSuspensionsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminSuspensionsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getAdminUsersListUrl = (params?: AdminUsersListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/users/?${stringifiedParams}` : `/api/admin/users/`
}

/**
 * Endpoint to list users and their details. Accessible to Gigpro admins and agent admins
 */
export const adminUsersList = async (params?: AdminUsersListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedUserResponseList> => {

  return customFetch<PaginatedUserResponseList>(getAdminUsersListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminUsersListInfiniteQueryKey = (params?: AdminUsersListParams,) => {
    return [
    'infinite', `/api/admin/users/`, ...(params ? [params] : [])
    ] as const;
    }

export const getAdminUsersListQueryKey = (params?: AdminUsersListParams,) => {
    return [
    `/api/admin/users/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminUsersListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof adminUsersList>>, AdminUsersListParams['page']>, TError = void>(params?: AdminUsersListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminUsersList>>, TError, TData, QueryKey, AdminUsersListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminUsersListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminUsersList>>, QueryKey, AdminUsersListParams['page']> = ({ signal, pageParam }) => adminUsersList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminUsersList>>, TError, TData, QueryKey, AdminUsersListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminUsersListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminUsersList>>>
export type AdminUsersListInfiniteQueryError = void


export function useAdminUsersListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminUsersList>>, AdminUsersListParams['page']>, TError = void>(
 params: undefined |  AdminUsersListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminUsersList>>, TError, TData, QueryKey, AdminUsersListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminUsersList>>,
          TError,
          Awaited<ReturnType<typeof adminUsersList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminUsersListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminUsersList>>, AdminUsersListParams['page']>, TError = void>(
 params?: AdminUsersListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminUsersList>>, TError, TData, QueryKey, AdminUsersListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminUsersList>>,
          TError,
          Awaited<ReturnType<typeof adminUsersList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminUsersListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminUsersList>>, AdminUsersListParams['page']>, TError = void>(
 params?: AdminUsersListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminUsersList>>, TError, TData, QueryKey, AdminUsersListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminUsersListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminUsersList>>, AdminUsersListParams['page']>, TError = void>(
 params?: AdminUsersListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminUsersList>>, TError, TData, QueryKey, AdminUsersListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminUsersListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminUsersListQueryOptions = <TData = Awaited<ReturnType<typeof adminUsersList>>, TError = void>(params?: AdminUsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminUsersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminUsersListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminUsersList>>> = ({ signal }) => adminUsersList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminUsersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminUsersListQueryResult = NonNullable<Awaited<ReturnType<typeof adminUsersList>>>
export type AdminUsersListQueryError = void


export function useAdminUsersList<TData = Awaited<ReturnType<typeof adminUsersList>>, TError = void>(
 params: undefined |  AdminUsersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminUsersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminUsersList>>,
          TError,
          Awaited<ReturnType<typeof adminUsersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminUsersList<TData = Awaited<ReturnType<typeof adminUsersList>>, TError = void>(
 params?: AdminUsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminUsersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminUsersList>>,
          TError,
          Awaited<ReturnType<typeof adminUsersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminUsersList<TData = Awaited<ReturnType<typeof adminUsersList>>, TError = void>(
 params?: AdminUsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminUsersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminUsersList<TData = Awaited<ReturnType<typeof adminUsersList>>, TError = void>(
 params?: AdminUsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminUsersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminUsersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminUsersSwapPhoneNumbersCreateUrl = () => {




  return `/api/admin/users/swap-phone-numbers/`
}

/**
 * This endpoint is used to swap the phone numbers of two users.
 * It is intended for use by specific Gigpro admins only.
 * Permissions are handled in the service layer using a feature flag.
 */
export const adminUsersSwapPhoneNumbersCreate = async (swapPhoneNumbersRequest: SwapPhoneNumbersRequest, options?: Parameters<typeof customFetch>[1]): Promise<SwapPhoneNumbers> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<SwapPhoneNumbers>(getAdminUsersSwapPhoneNumbersCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(swapPhoneNumbersRequest)
  }
);}





export const getAdminUsersSwapPhoneNumbersCreateMutationKey = () => ['adminUsersSwapPhoneNumbersCreate'] as const;

export const getAdminUsersSwapPhoneNumbersCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUsersSwapPhoneNumbersCreate>>, TError,AdminUsersSwapPhoneNumbersCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUsersSwapPhoneNumbersCreate>>, TError,AdminUsersSwapPhoneNumbersCreateMutationVariables, TContext> => {

const mutationKey = getAdminUsersSwapPhoneNumbersCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUsersSwapPhoneNumbersCreate>>, AdminUsersSwapPhoneNumbersCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminUsersSwapPhoneNumbersCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUsersSwapPhoneNumbersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminUsersSwapPhoneNumbersCreate>>>
    export type AdminUsersSwapPhoneNumbersCreateMutationBody = SwapPhoneNumbersRequest
    export type AdminUsersSwapPhoneNumbersCreateMutationError = void
    export type AdminUsersSwapPhoneNumbersCreateMutationVariables = {data: SwapPhoneNumbersRequest}

    export const useAdminUsersSwapPhoneNumbersCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUsersSwapPhoneNumbersCreate>>, TError,AdminUsersSwapPhoneNumbersCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminUsersSwapPhoneNumbersCreate>>,
        TError,
        AdminUsersSwapPhoneNumbersCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminUsersSwapPhoneNumbersCreateMutationOptions(options), queryClient);
    }
    export const getAdminVerificationsCreateUrl = () => {




  return `/api/admin/verifications/`
}

/**
 * A Verification contains details about manual verification made by Gigpro admins to Pro profiles.
 *
 * This API is designed for GigPro admins to manage Pro manual verifications
 */
export const adminVerificationsCreate = async (proCreateVerificationRequest: ProCreateVerificationRequest, options?: Parameters<typeof customFetch>[1]): Promise<ProCreateVerification> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ProCreateVerification>(getAdminVerificationsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(proCreateVerificationRequest)
  }
);}





export const getAdminVerificationsCreateMutationKey = () => ['adminVerificationsCreate'] as const;

export const getAdminVerificationsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVerificationsCreate>>, TError,AdminVerificationsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVerificationsCreate>>, TError,AdminVerificationsCreateMutationVariables, TContext> => {

const mutationKey = getAdminVerificationsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVerificationsCreate>>, AdminVerificationsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminVerificationsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVerificationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminVerificationsCreate>>>
    export type AdminVerificationsCreateMutationBody = ProCreateVerificationRequest
    export type AdminVerificationsCreateMutationError = void
    export type AdminVerificationsCreateMutationVariables = {data: ProCreateVerificationRequest}

    export const useAdminVerificationsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVerificationsCreate>>, TError,AdminVerificationsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVerificationsCreate>>,
        TError,
        AdminVerificationsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVerificationsCreateMutationOptions(options), queryClient);
    }
    export const getAdminVerificationsUpdateUrl = (id: number,) => {




  return `/api/admin/verifications/${id}/`
}

/**
 * A Verification contains details about manual verification made by Gigpro admins to Pro profiles.
 *
 * This API is designed for GigPro admins to manage Pro manual verifications
 */
export const adminVerificationsUpdate = async (id: number,
    proUpdateVerificationRequest?: ProUpdateVerificationRequest, options?: Parameters<typeof customFetch>[1]): Promise<ProUpdateVerification> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ProUpdateVerification>(getAdminVerificationsUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(proUpdateVerificationRequest)
  }
);}





export const getAdminVerificationsUpdateMutationKey = () => ['adminVerificationsUpdate'] as const;

export const getAdminVerificationsUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVerificationsUpdate>>, TError,AdminVerificationsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVerificationsUpdate>>, TError,AdminVerificationsUpdateMutationVariables, TContext> => {

const mutationKey = getAdminVerificationsUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVerificationsUpdate>>, AdminVerificationsUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  adminVerificationsUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVerificationsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminVerificationsUpdate>>>
    export type AdminVerificationsUpdateMutationBody = ProUpdateVerificationRequest | undefined
    export type AdminVerificationsUpdateMutationError = void
    export type AdminVerificationsUpdateMutationVariables = {id: number;data?: ProUpdateVerificationRequest}

    export const useAdminVerificationsUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVerificationsUpdate>>, TError,AdminVerificationsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVerificationsUpdate>>,
        TError,
        AdminVerificationsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVerificationsUpdateMutationOptions(options), queryClient);
    }
    export const getAdminVerificationsPartialUpdateUrl = (id: number,) => {




  return `/api/admin/verifications/${id}/`
}

/**
 * A Verification contains details about manual verification made by Gigpro admins to Pro profiles.
 *
 * This API is designed for GigPro admins to manage Pro manual verifications
 */
export const adminVerificationsPartialUpdate = async (id: number,
    patchedProUpdateVerificationRequest?: PatchedProUpdateVerificationRequest, options?: Parameters<typeof customFetch>[1]): Promise<ProUpdateVerification> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ProUpdateVerification>(getAdminVerificationsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedProUpdateVerificationRequest)
  }
);}





export const getAdminVerificationsPartialUpdateMutationKey = () => ['adminVerificationsPartialUpdate'] as const;

export const getAdminVerificationsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVerificationsPartialUpdate>>, TError,AdminVerificationsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVerificationsPartialUpdate>>, TError,AdminVerificationsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminVerificationsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVerificationsPartialUpdate>>, AdminVerificationsPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  adminVerificationsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVerificationsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminVerificationsPartialUpdate>>>
    export type AdminVerificationsPartialUpdateMutationBody = PatchedProUpdateVerificationRequest | undefined
    export type AdminVerificationsPartialUpdateMutationError = void
    export type AdminVerificationsPartialUpdateMutationVariables = {id: number;data?: PatchedProUpdateVerificationRequest}

    export const useAdminVerificationsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVerificationsPartialUpdate>>, TError,AdminVerificationsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVerificationsPartialUpdate>>,
        TError,
        AdminVerificationsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVerificationsPartialUpdateMutationOptions(options), queryClient);
    }
